<template>
    <LoadingSpinner v-if="loadingStatus || loading" />
    <!--<div class="pqHeadFirst">
          <div class="crmPageTitle">{{ pageTitle }}</div>
      </div>-->
    <div id="pqPopup"></div>
    <TopicEntryWidget ref="TopicLinkEntry" @changed="topicEntryWidgetChanged" />
    <ChangeTopicStatusPopup ref="changeTopicStatusPopup"
                            @statusChanged="statusChanged"
                            @statusTopicLinkChanged="statusTopicLinkChanged"></ChangeTopicStatusPopup>

    <DxPopup v-model:visible="popup.visible"
             :title="popup.title"
             width="auto"
             height="auto"
             container="#pqPopup"
             :content-template="popup.template">
        <template #statusChange>
            <div class="puChangeState">
                <div class="puChangeStateMessage" v-html="popup.message"></div>
                <div class="puChangeMessage" v-if="popup.hasChangeNotification">
                    <div class="puChangeStateMailTitle">Email Message:</div>
                    <div class="puChangeStateMail">
                        <DxHtmlEditor v-model:value="popup.mailText"
                                      value-type="html"
                                      ref="EmailEditor"
                                      :height="200"
                                      class="html-dx-field">
                            <DxToolbar>
                                <DxItem name="undo" />
                                <DxItem name="redo" />
                                <DxItem name="separator" />
                                <DxItem name="bold" />
                                <DxItem name="italic" />
                                <DxItem name="strike" />
                                <DxItem name="underline" />
                                <DxItem name="separator" />
                                <DxItem name="alignLeft" />
                                <DxItem name="alignCenter" />
                                <DxItem name="alignRight" />
                                <DxItem name="alignJustify" />
                                <DxItem name="separator" />
                                <DxItem name="color" />
                                <DxItem name="background" />
                            </DxToolbar>
                        </DxHtmlEditor>
                    </div>
                </div>
                <div class="assigneeSelection" v-if="popup.showAssigneeSelection">
                    <div class="assigneeSelectionLabel">Select Assignee:</div>
                    <div class="assigneeSelectionValue">
                        <DxSelectBox :data-source="userListForGroup"
                                     :show-clear-button="true"
                                     search-mode="contains"
                                     display-expr="UsrFullName"
                                     select-all-mode="allPages"
                                     value-expr="UsrId"
                                     :search-enabled="true"
                                     placeholder="Choose Assignee"
                                     v-model:value="selectedUsrIdForAction">
                        </DxSelectBox>
                    </div>
                </div>
                <div class="expertsSelection" v-if="popup.showExpertsSelection">
                    <div class="assigneeSelectionLabel">Select Experts:</div>
                    <div class="assigneeSelectionValue">
                        <DxTagBox :data-source="popup.expertsListForGroup"
                                  :show-selection-controls="true"
                                  :show-clear-button="true"
                                  display-expr="UsrFullName"
                                  value-expr="UsrId"
                                  :search-enabled="true"
                                  placeholder="Choose Expert"
                                  v-model:selected-items="selectedExperts">
                        </DxTagBox>
                    </div>
                </div>

                <div class="puChangeStateButtons">
                    <div class="puChangeStateButton">
                        <DxButton text="Cancel"
                                  @click="popupCancel"
                                  type="default"></DxButton>
                    </div>
                    <div class="puChangeStateButton">
                        <DxButton text="OK"
                                  @click="changeStateOnServer"
                                  type="success"></DxButton>
                    </div>
                </div>
            </div>
        </template>
        <template #addTopicLink>
            <div class="puBox">
                <div class="puCell">
                    <div class="puCellTpl"
                         v-if="
                         popup.action.TltCategoryItems &&
                         popup.action.TltCategoryItems.length>
                        0
                        "
                        >
                        <div class="puLabel">
                            {{
                popup.action.TltCategoryName
                  ? popup.action.TltCategoryName
                  : "Category"
                            }}:
                        </div>
                        <div class="puValue">
                            <DxSelectBox :data-source="popup.action.TltCategoryItems"
                                         :show-clear-button="true"
                                         display-expr="LitName"
                                         value-expr="LitId"
                                         width="350"
                                         v-model:value="actionCategoryId">
                                <template #selectItem="{ data }">
                                    <Field v-html="data.ParsedTemplate" />
                                </template>
                            </DxSelectBox>
                        </div>
                    </div>
                    <div class="puCellTpl">
                        <div class="puLabel">Select:</div>
                        <div class="puValue" v-if="!popup.multiselect">
                            <DxSelectBox :data-source="topicLinksForLinking"
                                         :show-clear-button="true"
                                         @custom-item-creating="addingMfg"
                                         display-expr="ParsedTemplate"
                                         value-expr="TopicId"
                                         selected-expr="selected"
                                         item-template="selectItem"
                                         width="350"
                                         v-model:value="actionTopicId">
                                <template #selectItem="{ data }">
                                    <Field v-html="data.ParsedTemplate" />
                                </template>
                            </DxSelectBox>
                        </div>
                        <div v-else class="puValue">
                            <div class="crmPopupContent">
                                <div class="crmPopupBody">
                                    <DxScrollView direction="vertical"
                                                  show-scrollbar="always"
                                                  scroll-by-content="true"
                                                  scroll-by-thumb="true"
                                                  height="200">
                                        <DxTreeView id="treeviewMultislectEntryPoint"
                                                    :items="topicLinksForLinking"
                                                    height="100%"
                                                    ref="treeViewEntrypointRef"
                                                    show-check-boxes-mode="selectAll"
                                                    :search-enabled="true"
                                                    search-mode="contains"
                                                    keyExpr="TopicId"
                                                    display-expr="ParsedTemplate"
                                                    expandedExpr="expand"
                                                    selection-mode="multiple"
                                                    :select-nodes-recursive="false"
                                                    :select-by-click="true">
                                            <template #item="item">
                                                <Field v-html="item.data.ParsedTemplate" />
                                            </template>
                                        </DxTreeView>
                                    </DxScrollView>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="puChangeStateButtons">
                    <div class="puChangeStateButton">
                        <DxButton text="Cancel" @click="popupCancel" />
                    </div>
                    <div class="puChangeStateButton">
                        <DxButton text="Add"
                                  @click="addTopicLinkOnServer"
                                  type="danger"
                                  :disabled="actionTopicId == null && !actionTopicIds.length" />
                    </div>
                </div>
            </div>
        </template>
    </DxPopup>
    <DxValidationGroup name="validationGroup" ref="validationGroup">
        <div class="page-content">
            <div class="na-page">
                <form class="na-form" @submit="onSubmit($event)" ref="form">
                    <div id="cisTey"
                         :class="{
              home: true,
              crmReadOnly: formIsReadOnly,
              crmEditForm: !formIsReadOnly,
            }">
                        <div class="controlHeader" v-if="!loadingStatus">
                            <div class="crmButton crmBackButton">
                                <DxButton :text="btn.BtnBackToView"
                                          styling-mode="text"
                                          type="default"
                                          icon="fa-regular fa-circle-arrow-left"
                                          :use-submit-behavior="false"
                                          @click="navigateBack($event)" />
                            </div>
                            <div class="crmButton" v-if="!formIsReadOnly">
                                <DxButton :text="btn.BtnSave"
                                          styling-mode="text"
                                          icon="fa-light fa-floppy-disk"
                                          type="success"
                                          @click="update" />
                            </div>
                            <!--<div class="crmButton">
                                              <DxButton :text="btn.BtnDeepLink"
                                                        styling-mode="text"
                                                        icon="fa-light fa-floppy-disk"
                                                        type="success"
                                                        @click="getDeepLink" />
                                          </div>x-->

                            <div class="crmNavigator" v-if="showNavigator">
                                <DxButton icon="fa-solid fa-backward-fast"
                                          styling-mode="text"
                                          :disabled="!hasFirst"
                                          @click="gotoFirst()" />
                                <DxButton icon="fa-solid fa-backward-step"
                                          styling-mode="text"
                                          :disabled="!hasPrevious"
                                          @click="gotoPrevious()" />
                                <DxButton icon="fa-solid fa-forward-step"
                                          styling-mode="text"
                                          :disabled="!hasNext"
                                          @click="gotoNext()" />
                                <DxButton icon="fa-solid fa-forward-fast"
                                          styling-mode="text"
                                          :disabled="!hasLast"
                                          @click="gotoLast()" />
                            </div>
                            <div class="crmButton" v-if="accessList._300421">
                                <DxButton :text="btn.BtnDownloadPDF"
                                          styling-mode="text"
                                          icon="fa-light fa-file-pdf"
                                          type="default"
                                          @click="downloadPdfSingle" />
                                <DxButton :text="btn.BtnDownloadDocx"
                                          styling-mode="text"
                                          icon="fa-light fa-file-word"
                                          type="default"
                                          @click="downloadDocxSingle" />
                            </div>
                        </div>
                        <div class="crmContentArea"
                             v-if="!loadingStatus"
                             v-bind:class="{
                'cluster-class': topicTypeId == 23,
                crmReadOnly: formIsReadOnly,
              }">
                            <div class="crmVersionBox"
                                 v-if=" versionList &&
                                 versionList.length>
                                0 &&
                                accessList._300911 &&
                                (!formIsReadOnly || isHistoric)">
                                <div class="crmElements">
                                    <div class="cmHistory" v-if="isHistoric && currentStatus">
                                        <span class="cmHistoryCaption"> Version Status:</span> {{versionStatus}} <br />
                                        <span class="cmHistoryCaption"> Current Status:</span> {{currentStatus}}
                                    </div>

                                    <div class="crmDescription">
                                        <i class="crmVersionCaption fa-thin fa-rectangle-history"></i><span>Restore a previous version</span>
                                    </div>
                                    <div>
                                        <DxSelectBox :data-source="versionList"
                                                     css-class="crmVersionSelect"
                                                     :show-clear-button="true"
                                                     display-expr="Version"
                                                     value-expr="TimeStartUtc"
                                                     :search-enabled="true"
                                                     search-mode="contains"
                                                     @value-changed="selectedVersionChanged"
                                                     placeholder="Choose Version"
                                                     v-model:value="selectedVersion">
                                        </DxSelectBox>
                                    </div>
                                </div>
                                <div class="crmVersionInfo" v-if="isHistoric">
                                    Currently Viewing: Version
                                    {{ selectedVersionInfo.Version }}
                                </div>
                            </div>
                            <!-- Attributes / description -->
                            <div class="crmTitle" v-if="entryTitle > ''">
                                <div class="crmCaption" v-html="entryTitle"></div>
                            </div>

                            <div v-for="data in modulTypeAttributeList" :key="data.MatId">
                                <div :class="[data.className, data.ControlClass, 'crmElements']"
                                     v-if="
                    isVisible(data) &&
                    data.AtrId != 15 &&
                    (!formIsReadOnly ||
                      (data.Value != null && data.Value != '') ||
                      data.AtyId == 5)
                  ">
                                    <div class="crmElementHeader">
                                        <div class="crmCaptionBox"
                                             v-if="
                                             data.Caption &&
                                             data.Caption>
                                            '' &&
                                            (!data.HideCaptionInReadonly || !formIsReadOnly)
                                            "
                                            >
                                            <div class="crmCaption" v-html="data.Caption"></div>
                                        </div>
                                        <div v-if="data.AtyId == 9">
                                            <DxCheckBox v-model:value="data.Value"
                                                        class="crmCheckbox"
                                                        :readOnly="formIsReadOnly"
                                                        :enableThreeStateBehavior="false"></DxCheckBox>
                                        </div>
                                        <div class="crmRequired" v-if="!formIsReadOnly">
                                            {{ data.Required ? "*" : "" }}
                                        </div>
                                    </div>
                                    <div class="crmDescription"
                                         v-if="!formIsReadOnly"
                                         v-html="data.Description"></div>
                                    <div class="crmDescription readOnly"
                                         v-else-if="formIsReadOnly"
                                         v-html="data.Description2"></div>
                                    <div class="crmControl">
                                        <div v-if="data.AtyId == 23" class="crmContents">
                                            <div v-html="data.Value" class="crmTemplate"></div>
                                            <div class="cmHistory"
                                                 v-if="isHistoric && data.CurrentVersionValue">
                                                <div v-html="compareAndHighlight(data.CurrentVersionValue, data.Value)"></div>

                                            </div>

                                        </div>
                                        <div v-if="data.AtyId == 1 || data.AtyId == 2"
                                             class="crmContents">
                                            <div v-if="formIsReadOnly" class="crmContents">
                                                <dív v-if="data.DisplayAsHtml" class="crmContents">
                                                    <div v-html="removeFormatting(data.Value)"
                                                         class="crmContents"></div>
                                                </dív>
                                                <dív v-if="!data.DisplayAsHtml" class="crmContents">
                                                    <div v-if="isUrl(data.Value) ||(data.AtyId == 1 && data.MatIsHyperLink)
                            ">
                                                        <a v-html="data.Value"
                                                           :href="data.MatHyperLinkText"
                                                           target="_blank"
                                                           class="crmContents crmHyperlink"
                                                           v-if="data.AtyId == 1 && data.MatIsHyperLink">
                                                        </a>
                                                        <a v-else
                                                           :href="data.Value"
                                                           target="_blank"
                                                           class="crmContents crmHyperlink">{{ data.Value }}</a>
                                                    </div>

                                                    <div v-else v-html="makeBreaks(data.Value)"></div>
                                                </dív>
                                            </div>
                                            <div v-if="!formIsReadOnly" class="crmContents">
                                                <DxTextBox v-if="data.AtyId == 1 && data.DisplayAsHtml == false"
                                                           v-model:value="data.Value"
                                                           :placeholder="data.ToolTip"
                                                           :hint="data.ToolTip"
                                                           value-change-event="keyup"
                                                           :max-length="data.MaxLength">
                                                    <DxValidator name="data.Caption">
                                                        <DxRequiredRule v-if="data.Required"
                                                                        :message="data.RequiredMessage" />
                                                    </DxValidator>
                                                </DxTextBox>
                                                <DxTextArea v-if="data.AtyId == 2 && data.DisplayAsHtml == false"
                                                            v-model:value="data.Value"
                                                            :placeholder="data.ToolTip"
                                                            :hint="data.ToolTip"
                                                            value-change-event="keyup"
                                                            :autoResizeEnabled="true"
                                                            :max-length="data.MaxLength">
                                                    <DxValidator name="data.Caption">
                                                        <DxRequiredRule v-if="data.Required"
                                                                        :message="data.RequiredMessage" />
                                                    </DxValidator>
                                                </DxTextArea>
                                                <DxHtmlEditor v-if="data.DisplayAsHtml == true"
                                                              :placeholder="data.ToolTip"
                                                              :hint="data.ToolTip"
                                                              v-model:value="data.Value">
                                                    <DxValidator name="data.Caption">
                                                        <DxRequiredRule v-if="data.Required"
                                                                        :message="data.RequiredMessage" />
                                                    </DxValidator>
                                                    <DxMediaResizing :enabled="true" />
                                                    <DxToolbar :multiline="isMultiline">
                                                        <DxItem name="undo" />
                                                        <DxItem name="redo" />
                                                        <DxItem name="separator" />
                                                        <DxItem :accepted-values="sizeValues" name="size" />
                                                        <DxItem :accepted-values="fontValues" name="font" />
                                                        <DxItem name="separator" />
                                                        <DxItem name="bold" />
                                                        <DxItem name="italic" />
                                                        <DxItem name="strike" />
                                                        <DxItem name="underline" />
                                                        <DxItem name="separator" />
                                                        <DxItem name="alignLeft" />
                                                        <DxItem name="alignCenter" />
                                                        <DxItem name="alignRight" />
                                                        <DxItem name="alignJustify" />
                                                        <DxItem name="separator" />
                                                        <DxItem name="orderedList" />
                                                        <DxItem name="bulletList" />
                                                        <DxItem name="separator" />
                                                        <DxItem :accepted-values="headerValues"
                                                                name="header" />
                                                        <DxItem name="separator" />
                                                        <DxItem name="color" />
                                                        <DxItem name="background" />
                                                        <DxItem name="separator" />
                                                        <DxItem name="link" />
                                                        <DxItem name="image" />
                                                        <DxItem name="separator" />
                                                        <DxItem name="clear" />
                                                        <DxItem name="codeBlock" />
                                                        <DxItem name="blockquote" />
                                                        <DxItem name="separator" />
                                                        <DxItem name="insertTable" />
                                                        <DxItem name="deleteTable" />
                                                        <DxItem name="insertRowAbove" />
                                                        <DxItem name="insertRowBelow" />
                                                        <DxItem name="deleteRow" />
                                                        <DxItem name="insertColumnLeft" />
                                                        <DxItem name="insertColumnRight" />
                                                        <DxItem name="deleteColumn" />
                                                    </DxToolbar>
                                                </DxHtmlEditor>
                                                <div class="crmMaxLen"
                                                     v-html="getMaxLengthText(data)"></div>
                                            </div>
                                            <div class="cmHistory"
                                                 v-if="isHistoric && data.CurrentVersionValue">
                                                <div v-html="compareAndHighlight(data.CurrentVersionValue,data.Value)"></div>

                                            </div>

                                        </div>

                                        <div v-if="data.AtyId == 3">
                                            <div v-if="!formIsReadOnly" class="crmContents">
                                                <DxSelectBox v-model:value="data.Value"
                                                             v-model:text="data.SelectedText"
                                                             :data-source="data.SelectBoxItems"
                                                             :search-enabled="true"
                                                             search-mode="contains"
                                                             display-expr="Text"
                                                             value-expr="Value"
                                                             placeholder="Select a value...">
                                                    <DxValidator name="data.Caption">
                                                        <DxRequiredRule v-if="data.Required"
                                                                        :message="data.RequiredMessage" />
                                                    </DxValidator>
                                                </DxSelectBox>
                                            </div>
                                            <div v-if="formIsReadOnly" class="crmContents">
                                                <div class="msbSelectBox">
                                                    <i :class="handleIcon(data.SelectBoxItems, data)"></i>
                                                    <div class="sbList"
                                                         v-html="
                              handleDisplayText(data.SelectBoxItems, data)
                            "></div>
                                                </div>
                                            </div>
                                            <div class="cmHistory"
                                                 v-if="isHistoric && data.CurrentVersionValue">
                                                <div v-html="compareAndHighlight(data.CurrentVersionValue, data.SelectedText)"></div>
                                            </div>

                                        </div>
                                        <div v-if="data.AtyId == 5"></div>
                                        <div v-if="data.AtyId == 9"></div>
                                        <div v-if="data.AtyId == 11" class="crmContents">
                                            <div v-if="formIsReadOnly" class="crmContents">
                                                {{ this.moment(data.Value).format(data.Format) }}
                                            </div>
                                            <div v-if="!formIsReadOnly" class="crmContents">
                                                <DxDateBox v-model:value="data.Value"
                                                           :type="data.DataType"
                                                           :dateSerializationFormat="
                            data.DataType == 'date'
                              ? 'yyyy-MM-dd'
                              : 'yyyy-MM-ddTHH:mm:ss'
                          "
                                                           :use-mask-behavior="true"
                                                           :display-format="
                            data.DataType == 'date'
                              ? 'dd/MM/yyyy'
                              : 'dd/MM/yyyy HH:mm'
                          "
                                                           :placeholder="data.ToolTip"
                                                           :show-clear-button="true">
                                                    <DxValidator name="data.Caption">
                                                        <DxRequiredRule v-if="data.Required"
                                                                        :message="data.RequiredMessage" />
                                                    </DxValidator>
                                                </DxDateBox>
                                            </div>
                                            <div class="cmHistory"
                                                 v-if="isHistoric && data.CurrentVersionValue">
                                                {{ data.CurrentVersionValue }}
                                            </div>

                                        </div>
                                        <div v-if="data.AtyId == 18" class="crmContents">
                                            <div v-if="formIsReadOnly" class="crmContents">
                                                {{ data.Value }}
                                            </div>
                                            <div v-if="!formIsReadOnly" class="crmContents">
                                                <DxNumberBox v-model:value="data.Value"
                                                             :show-clear-button="true"
                                                             :show-spin-buttons="true"
                                                             mode="number">
                                                    <DxValidator name="data.Caption">
                                                        <DxRequiredRule v-if="data.Required"
                                                                        :message="data.RequiredMessage" />
                                                    </DxValidator>
                                                </DxNumberBox>
                                            </div>
                                            <div class="cmHistory"
                                                 v-if="isHistoric && data.CurrentVersionValue">
                                                {{ data.CurrentVersionValue }}
                                            </div>

                                        </div>
                                        <div v-if="data.AtyId == 14 || data.AtyId == 21">
                                            <div v-if="!formIsReadOnly"
                                                 class="crmContents crmMultiSelectListText">
                                                <ul class="crmMultiSelectListText">
                                                    <li v-for="rec in data.allItems.filter(
                                                        (m)=>
                                                        m.selected == true
                                                        )"
                                                        :key="rec.value"
                                                        class="crmMultiSelectItem"
                                                        >
                                                        <span class="crmMultiSelectItemText">
                                                            {{
                              rec.text
                                                            }}
                                                        </span>
                                                        <span class="crmMultiSelectItemDelete"
                                                              @click="deleteMultiselectItem(data, rec)">
                                                            <i class="fa-regular fa-circle-xmark"></i>
                                                        </span>
                                                    </li>
                                                    <li class="crmMultiSelectItem crmMultiSelectItemAdd"
                                                        @click="addMultiselectItem(data)">
                                                        <div class="crmMultiSelectIconAdd">
                                                            <i class="fa-solid fa-plus"></i>
                                                        </div>
                                                    </li>
                                                </ul>
                                                <DxNumberBox :value="
                                                             data.Value>
                                                    '' ? data.Value.split(',').length : 0
                                                    "
                                                    :element-attr="{ class: 'crmValidationBox' }"
                                                    :readOnly="true"
                                                    :min="data.MinLength"
                                                    :max="data.MaxLength"
                                                    >
                                                    <DxValidator name="data.Caption">
                                                        <DxRangeRule :min="data.MinLength"
                                                                     :max="99999999"
                                                                     type="range"
                                                                     :message="data.RangeMessage"
                                                                     :reevaluate="true" />
                                                    </DxValidator>
                                                </DxNumberBox>
                                                <DxPopup v-model:visible="data.ShowSelectionPopup"
                                                         :hide-on-outside-click="false"
                                                         title="Please Select"
                                                         :height="500"
                                                         :width="500"
                                                         :show-close-button="true">
                                                    <div class="crmPopupContent">
                                                        <div class="crmPopupBody">
                                                            <DxTreeView id="treeview"
                                                                        v-model:value="data.Value"
                                                                        height="100%"
                                                                        ref="treeViewRef"
                                                                        :items="data.groupData"
                                                                        show-check-boxes-mode="normal"
                                                                        :search-enabled="true"
                                                                        search-mode="contains"
                                                                        keyExpr="Value"
                                                                        selectedExpr="selected"
                                                                        expandedExpr="expand"
                                                                        selection-mode="multiple"
                                                                        @itemRenderedX="(e) => treeItemRender(e, data)"
                                                                        @itemSelectionChanged="
                                                                        (e)=>
                                                                treeClick(e, data)
                                                                "
                                                                @selection-changed="
                                                                (e) => treeViewSelectionChanged(e, data)
                                                                "
                                                                :select-nodes-recursive="false"
                                                                :select-by-click="true"
                                                                >
                                                                <template #item="item">
                                                                    {{ item.data.text }}
                                                                </template>
                                                            </DxTreeView>
                                                        </div>
                                                        <div class="crmPopupFooter">
                                                            <DxButton :text="btn.BtnSelect"
                                                                      type="default"
                                                                      @click="closeMultiselectPopup(data)"></DxButton>
                                                        </div>
                                                    </div>
                                                </DxPopup>
                                            </div>
                                            <div v-if="formIsReadOnly" class="crmContents">
                                                <div class="msbListBox">
                                                    <ul class="msbList"
                                                        v-html="
                              handleMultiSelectText(
                                data.SelectBoxItems,
                                data.SelectedKeys,
                                data
                              )
                            "></ul>
                                                </div>
                                            </div>
                                            <div class="cmHistory"
                                                 v-if="isHistoric && data.CurrentVersionValue">
                                                {{ data.CurrentVersionValue }}
                                            </div>

                                        </div>
                                        <TopicLinkSelectList v-if="data.AtyId == 24"
                                                             :mat-id="data.MatId"
                                                             :config="data"
                                                             v-model="data.Value"
                                                             @closed="handleTopicLinkSelectListClosed"
                                                             :formIsReadOnly="formIsReadOnly || data.ReadOnly"
                                                             :btn="btn" />

                                        <div v-if="data.AtyId == 17 && data.MatOptions">
                                            <DxSlider v-model:selectedValue="data.Value"
                                                      :disabled="formIsReadOnly"
                                                      :min="data.MatOptionsParsed.from"
                                                      :max="data.MatOptionsParsed.to"
                                                      :step="data.MatOptionsParsed.step">
                                                <DxLabel :visible="true" position="top"></DxLabel>
                                            </DxSlider>
                                            <div class="cmHistory"
                                                 v-if="isHistoric && data.CurrentVersionValue">
                                                {{ data.CurrentVersionValue }}
                                            </div>

                                        </div>
                                        <div v-if="data.AtyId == 19 && data.Value != null"
                                             class="crmImageBox">
                                            <div v-for="img in data.Value"
                                                 :key="img.TfiId"
                                                 class="crmImages">
                                                <div v-if="
                            img.MediaType == 'Image' ||
                            img.MediaType == 'Picture'
                          "
                                                     class="crmImageDiv">
                                                    <a :href="img.SourceUrl" target="_blank">
                                                        <div class="crmImage">
                                                            <img :src="img.Url" />
                                                        </div>
                                                    </a>
                                                    <div class="crmImageDelete" v-if="!formIsReadOnly">
                                                        <DxButton icon="fa fa-trash"
                                                                  @click="deleteImage(img, data)"></DxButton>
                                                    </div>
                                                    <div :class="{
                              crmDownload: true,
                              crmDownloadReadonly: formIsReadOnly,
                            }">
                                                        <a class="downloadDocument"
                                                           :href="img.SourceUrl"
                                                           target="_blank"
                                                           :download="img.TfiFileName">
                                                            <i class="fa-light fa-arrow-down-to-line"></i>
                                                            {{ img.TfiFileName }}
                                                        </a>
                                                    </div>
                                                </div>
                                                <div v-if="
                            img.MediaType != 'Image' &&
                            img.MediaType != 'Picture'
                          "
                                                     class="crmDocumentDiv">
                                                    <div class="crmImage">
                                                        <a :href="img.Url" target="_blank">
                                                            <i class="fa-duotone fa-file-contract"></i>
                                                        </a>
                                                    </div>
                                                    <div class="crmImageDelete" v-if="!formIsReadOnly">
                                                        <DxButton icon="fa fa-trash"
                                                                  @click="deleteImage(img, data)"></DxButton>
                                                    </div>
                                                    <div :class="{
                              crmDownload: true,
                              crmDownloadReadonly: formIsReadOnly,
                            }">
                                                        <a :href="img.Url"
                                                           target="_blank"
                                                           :download="img.TfiFileName">
                                                            <i class="fa-light fa-arrow-down-to-line"></i>
                                                            {{ img.TfiFileName }}
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="data.AtyId == 19 && !formIsReadOnly"
                                             class="crmContents crmUpload">
                                            <DxNumberBox :value="data.Value.length"
                                                         :readOnly="true"
                                                         :element-attr="{ class: 'crmValidationBox' }"
                                                         :min="data.MinFilesCount"
                                                         :max="data.MaxFilesCount">
                                                <DxValidator name="data.Caption">
                                                    <DxRangeRule :min="data.MinFilesCount"
                                                                 :max="data.MaxFilesCount"
                                                                 type="range"
                                                                 :message="data.RangeMessage"
                                                                 :reevaluate="true" />
                                                </DxValidator>
                                            </DxNumberBox>
                                            <DxFileUploader :select-button-text="btn.BtnSelectFile"
                                                            :disabled="
                                                            data.Value &&
                                                            data.MatMaxFiles>
                                                0 &&
                                                data.Value.length >= data.MatMaxFiles
                                                "
                                                :label-text="data.ToolTip"
                                                :tool-tip="data.ToolTip"
                                                :max-file-size="data.MaxLength"
                                                :min-file-size="data.MinLength"
                                                :accept="data.RtmMimeType"
                                                @uploaded="(e) => fileUploaded(e, data)"
                                                @value-changed="(e) => addUploadParameter(e, data)"
                                                upload-mode="instantly"
                                                :upload-url="uploadUrl"
                                                >
                                                <DxValidator name="data.Caption">
                                                    <DxCustomRule :validation-callback="
                                                                  (e)=>
                                                        fileValidating(e, data)
                                                        "
                                                        message="x"
                                                        />
                                                </DxValidator>
                                            </DxFileUploader>
                                        </div>
                                        <div v-if="data.AtyId == 22">
                                            <div class="crmPhotoBox">
                                                <div class="crmNoPhoto"
                                                     v-if="
                            !data.Value ||
                            !data.Value.Url ||
                            data.Value.Url.length == 0
                          ">
                                                    <div class="crmNoPhotoText" v-if="!formIsReadOnly">
                                                        {{ data.ToolTip }}
                                                    </div>
                                                </div>
                                                <img v-else :src="data.Value ? data.Value.Url : null" />
                                                <div v-if="!formIsReadOnly" class="crmUploadButton">
                                                    <my-upload field="img"
                                                               @crop-success="
                                                               (imgDataUrl, field)=>
                                                        cropSuccess(imgDataUrl, field, data.Value)
                                                        "
                                                        @crop-upload-success="cropUploadSuccess"
                                                        @crop-upload-fail="cropUploadFail"
                                                        v-model="showCropper"
                                                        :width="
                                                        data.MatOptionsParsed != null &&
                                                        data.MatOptionsParsed.MinWidth != null
                                                        ? data.MatOptionsParsed.MinWidth
                                                        : 250
                                                        "
                                                        :height="
                                                        data.MatOptionsParsed != null &&
                                                        data.MatOptionsParsed.MinHeight != null
                                                        ? data.MatOptionsParsed.MinHeight
                                                        : 250
                                                        "
                                                        :params="cropperParams"
                                                        :headers="cropperHeaders"
                                                        :langExt="cropperLanguageExtend"
                                                        img-format="png"
                                                        >
                                                    </my-upload>

                                                    <DxButton text="Select File"
                                                              @click="toggleShowCropper"></DxButton>
                                                </div>
                                            </div>
                                            <div class="cmHistory"
                                                 v-if="isHistoric && data.CurrentVersionValue">
                                                {{ data.CurrentVersionValue }}
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="crmElements" v-if="showVoting || allowPublicVoting">
                                <div v-if="showVoting" class="crmVotingArea">
                                    <TopicVoting :topicId="currentTopicId"
                                                 :rtgId="rtgId"></TopicVoting>
                                </div>
                                <div v-if="allowPublicVoting" class="crmVotingArea">
                                    <TopicPublicVoting :topicId="currentTopicId"
                                                       :rtgId="publicVotingRtgId"></TopicPublicVoting>
                                </div>
                                <!--<div v-if="publicVotingConfig.AllowView" class="crmVotingArea">
                                    <TopicPublicVoting :topicId="currentTopicId"></TopicPublicVoting>
                                </div>-->
                            </div>

                            <div v-if="
                  topicLinkListHasStgPublished &&
                  (showLinkList || showStatusInfo) &&
                  showGrids
                "
                                 class="drawers">
                                <DxButton @click="openDrawerGrid"
                                          type="default"
                                          styling-mode="text"
                                          class="drawer-btn">
                                    <div class="drawer-title drawer-status-text">
                                        <span>Tables</span>
                                        <i class="fa-light fa-caret-down" />
                                    </div>
                                </DxButton>
                                <DxLoadPanel :position="{ of: '#linkListDrawer1' }"
                                             v-model:visible="loadingLinkListVisible"
                                             :show-indicator="true"
                                             :show-pane="true"
                                             :shading="true"
                                             shading-color="rgba(0,0,0,0.4)" />
                                <DxDrawer id="linkListDrawer1"
                                          opened-state-mode="shrink"
                                          :position="selectedPosition"
                                          :reveal-mode="selectedRevealMode"
                                          v-model:opened="openStateGrid"
                                          :close-on-outside-click="true"
                                          template="drawerGrid">
                                    <template #drawerGrid>
                                        <div class="drawerGrid-elements">
                                            <div v-for="topicLink in topicLinkList"
                                                 :key="topicLink.TltId"
                                                 class="grid-element">
                                                <!--{{topicLink}}-->
                                                <DxDataGrid :data-source="
                                                            topicLink.Topics.filter((m)=>
                                                    m.StgId == 15)
                                                    "
                                                    :key-expr="TopicId"
                                                    :filter-row-visible="true"
                                                    :allow-column-reordering="true"
                                                    :allowColumnResizing="true"
                                                    @exporting="onExporting"
                                                    :show-borders="true"
                                                    columnAutoWidth="true"
                                                    :row-alternation-enabled="true"
                                                    v-if="
                                                    topicLink.Topics.filter((m) => m.StgId == 15)
                                                    .length > 0 && topicLink.TltId != 8
                                                    "
                                                    >
                                                    <DxScrolling row-rendering-mode="standard" />
                                                    <DxPaging :page-size="10" />
                                                    <DxPager :visible="true"
                                                             :allowed-page-sizes="pageSizes"
                                                             :display-mode="full"
                                                             :show-page-size-selector="true"
                                                             :show-info="true"
                                                             :show-navigation-buttons="true" />
                                                    <DxExport :enabled="true"
                                                              :formats="['xlsx', 'pdf']"
                                                              :allow-export-selected-data="true" />
                                                    <DxSelection :show-check-boxes-mode="checkBoxesMode"
                                                                 mode="multiple"
                                                                 select-all-mode="allPages"
                                                                 allow-select-all="true" />
                                                    <DxColumn :group-index="0"
                                                              data-field="TltCaptionDirection2"
                                                              :caption="column.ColType" />
                                                    <DxColumn data-field="TopicId"
                                                              :width="100"
                                                              :allow-editing="false"
                                                              :sort-index="0"
                                                              caption="Id"
                                                              data-type="string" />
                                                    <DxColumn :allow-editing="false"
                                                              :sort-index="0"
                                                              :caption="column.Colname"
                                                              data-type="string"
                                                              :customize-text="customizeText"
                                                              data-field="ParsedHtml" />
                                                    <DxColumn :allow-editing="false"
                                                              :sort-index="0"
                                                              :caption="column.ColRol"
                                                              data-type="string"
                                                              width="110"
                                                              data-field="TtyName" />

                                                    <DxColumn data-field="StatusName"
                                                              :allow-editing="false"
                                                              :sort-index="0"
                                                              :caption="column.ColStatus"
                                                              data-type="string" />
                                                </DxDataGrid>
                                            </div>
                                        </div>
                                    </template>
                                </DxDrawer>
                            </div>
                            <div class="graph-box" v-if="showNetworkChart">
                                <NetworkChartForSingleRecord ref="networkChart"
                                                             :topicId="currentTopicId"
                                                             :edge-expansion-rules="edgeExpansionRules"
                                                             @refresh="updateChart"
                                                             @openLinkedDetail="openLinkedDetail"
                                                             :key="chartKey"></NetworkChartForSingleRecord>
                            </div>

                            <div v-if="
                  (showLinkList || showStatusInfo) && topicLinkList.length != 0
                "
                                 class="drawers">
                                <DxButton @click="openDrawer"
                                          type="default"
                                          styling-mode="text"
                                          class="drawer-btn">
                                    <div class="drawer-title drawer-status-text">
                                        <span>Mapping</span>
                                        <i class="fa-light fa-caret-down" />
                                    </div>
                                </DxButton>

                                <!-- Blaue Liste -->
                                <DxLoadPanel :position="{ of: '#linkListDrawer2' }"
                                             v-model:visible="loadingLinkListVisible"
                                             :show-indicator="true"
                                             :show-pane="true"
                                             :shading="true"
                                             shading-color="rgba(0,0,0,0.4)" />
                                <DxDrawer id="linkListDrawer2"
                                          opened-state-mode="shrink"
                                          :position="selectedPosition"
                                          :reveal-mode="selectedRevealMode"
                                          v-model:opened="openState"
                                          :close-on-outside-click="true"
                                          template="drawerStatus">
                                    <template #drawerStatus>
                                        <div class="crmElements drawer">
                                            <div class="drawer-elements">
                                                <div v-if="showLinkList"
                                                     class="mapping-accordion-wrapper">
                                                    <!-- Static (non-collapsible) groups -->
                                                    <div v-for="grp in mappedGroups.staticGroups"
                                                         :key="'static-' + grp.rawCaption"
                                                         class="map-group-static">
                                                        <div class="map-static-title">
                                                            <span class="title">{{ grp.rawCaption }}</span>
                                                            <span class="count">({{ grp.grp.length }})</span>
                                                        </div>
                                                        <div class="map-static-body">
                                                            <div class="tlLinkListBox">
                                                                <div v-for="topic in grp.grp"
                                                                     :key="topic.TopicId"
                                                                     class="tlLinkItem"
                                                                     style="
                                    border-bottom: solid 1px rgb(223, 223, 224);
                                  ">
                                                                    <div style="display: contents">
                                                                        <div class="ttlIcon"
                                                                             @click="openLinkedDetail(topic.TopicId)">
                                                                            <i v-if="topic.TtyIcon"
                                                                               :class="topic.TtyIcon + ' vdIcon'">
                                                                                <span class="tooltiptext">
                                                                                    Related
                                                                                    {{ topic.TtyShortName }}
                                                                                </span>
                                                                            </i>
                                                                        </div>
                                                                        <div>
                                                                            <div class="tliEditButton"
                                                                                 v-if="topicAccess.Update"
                                                                                 @click="
                                          openEditLinkPopup(
                                            topic.TliId,
                                            topic.TpcTitle,
                                            topic.TopicId,
                                            topic.IsReversed ?? false
                                          )
                                        ">
                                                                                <i class="fa-solid fa-pen-to-square"></i>
                                                                            </div>
                                                                            <div v-else>&bull;</div>
                                                                        </div>
                                                                        <div class="tlLinkTemplate"
                                                                             :id="'lnkStatic' + topic.TliId"
                                                                             @click="openLinkedDetail(topic.TopicId)">
                                                                            <div class="tlLTopicId"
                                                                                 v-html="topic.ParsedHtml"></div>
                                                                            <div v-if="topic.TdgMemo001 > ''">
                                                                                <i class="fa-solid fa-circle-info"></i>
                                                                                <DxTooltip :target="'#lnkStatic' + topic.TliId"
                                                                                           show-event="mouseenter"
                                                                                           hide-event="mouseleave"
                                                                                           position="bottom"
                                                                                           width="auto"
                                                                                           maxWidth="50%"
                                                                                           height="auto"
                                                                                           :hide-on-outside-click="false">
                                                                                    <div style="text-wrap-mode: wrap">
                                                                                        {{ topic.TdgMemo001 }}
                                                                                    </div>
                                                                                </DxTooltip>
                                                                            </div>
                                                                        </div>
                                                                        <div class="tlCategory">
                                                                            {{
                                        concatText(
                                          topic,
                                          topic.TdgMultiSelect001,
                                          topic.TdgList001Name,
                                          topic.TdgList002Name
                                        )
                                                                            }}
                                                                        </div>
                                                                        <div class="tlStatus" v-if="showStatusInfo">
                                                                            {{ topic.StatusName }}
                                                                        </div>
                                                                        <div v-else>&nbsp;</div>
                                                                        <div class="tlStatusList"
                                                                             v-if="showLinkStatusActions">
                                                                            <div class="tlStatusItem"
                                                                                 v-for="status in topic.StatusList"
                                                                                 :key="status.StatusID">
                                                                                <div class="tlAction"
                                                                                     @click="
                                            statusActionClick(
                                              currentTopicId,
                                              status.StatusID,
                                              topic.TliId
                                            )
                                          ">
                                                                                    {{ status.ActionButtonText }}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div v-else>&nbsp;</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <!-- Collapsible groups -->
                                                    <DxAccordion v-if="mappedGroups.collapsibleGroups.length"
                                                                 :data-source="mappedGroups.collapsibleGroups"
                                                                 :multiple="true"
                                                                 :collapsible="true"
                                                                 :animation-duration="150"
                                                                 :defer-rendering="true"
                                                                 item-title-template="mapTitle"
                                                                 item-template="mapContent"
                                                                 v-model:selected-items="accordionOpenItems"
                                                                 @selection-changed="onAccordionSelectionChanged">
                                                        <template #mapTitle="{ data }">
                                                            <div class="map-acc-title">
                                                                <span class="map-acc-text">
                                                                    {{
                                  data.rawCaption
                                                                    }}
                                                                </span>
                                                                <span class="map-acc-count">({{ data.grp.length }})</span>
                                                            </div>
                                                        </template>
                                                        <template #mapContent="{ data }">
                                                            <div class="map-acc-body">
                                                                <div class="tlLinkListBox">
                                                                    <div v-for="topic in data.grp"
                                                                         :key="topic.TopicId"
                                                                         class="tlLinkItem"
                                                                         style="
                                      border-bottom: solid 1px
                                        rgb(223, 223, 224);
                                    ">
                                                                        <div style="display: contents">
                                                                            <div class="ttlIcon"
                                                                                 @click="openLinkedDetail(topic.TopicId)">
                                                                                <i v-if="topic.TtyIcon"
                                                                                   :class="topic.TtyIcon + ' vdIcon'">
                                                                                    <span class="tooltiptext">
                                                                                        Related
                                                                                        {{ topic.TtyShortName }}
                                                                                    </span>
                                                                                </i>
                                                                            </div>
                                                                            <div>
                                                                                <div class="tliEditButton"
                                                                                     v-if="topicAccess.Update"
                                                                                     @click="
                                            openEditLinkPopup(
                                              topic.TliId,
                                              topic.TpcTitle,
                                              topic.TopicId,
                                              topic.IsReversed ?? false
                                            )
                                          ">
                                                                                    <i class="fa-solid fa-pen-to-square"></i>
                                                                                </div>
                                                                                <div v-else>&bull;</div>
                                                                            </div>
                                                                            <div class="tlLinkTemplate"
                                                                                 :id="'lnkAcc' + topic.TliId"
                                                                                 @click="openLinkedDetail(topic.TopicId)">
                                                                                <div class="tlLTopicId"
                                                                                     v-html="topic.ParsedHtml"></div>
                                                                                <div v-if="topic.TdgMemo001 > ''">
                                                                                    <i class="fa-solid fa-circle-info"></i>
                                                                                    <DxTooltip :target="'#lnkAcc' + topic.TliId"
                                                                                               show-event="mouseenter"
                                                                                               hide-event="mouseleave"
                                                                                               position="bottom"
                                                                                               width="auto"
                                                                                               maxWidth="50%"
                                                                                               height="auto"
                                                                                               :hide-on-outside-click="false">
                                                                                        <div style="text-wrap-mode: wrap">
                                                                                            {{ topic.TdgMemo001 }}
                                                                                        </div>
                                                                                    </DxTooltip>
                                                                                </div>
                                                                            </div>
                                                                            <div class="tlCategory">
                                                                                {{
                                          concatText(
                                            topic,
                                            topic.TdgMultiSelect001,
                                            topic.TdgList001Name,
                                            topic.TdgList002Name
                                          )
                                                                                }}
                                                                            </div>
                                                                            <div class="tlStatus"
                                                                                 v-if="showStatusInfo">
                                                                                {{ topic.StatusName }}
                                                                            </div>
                                                                            <div v-else>&nbsp;</div>
                                                                            <div class="tlStatusList"
                                                                                 v-if="showLinkStatusActions">
                                                                                <div class="tlStatusItem"
                                                                                     v-for="status in topic.StatusList"
                                                                                     :key="status.StatusID">
                                                                                    <div class="tlAction"
                                                                                         @click="
                                              statusActionClick(
                                                currentTopicId,
                                                status.StatusID,
                                                topic.TliId
                                              )
                                            ">
                                                                                        {{ status.ActionButtonText }}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div v-else>&nbsp;</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </template>
                                                    </DxAccordion>
                                                </div>

                                                <!-- Status block -->
                                                <div style="display: contents" v-if="showStatusInfo">
                                                    <div class="crmElementHeader">
                                                        <div class="crmCaption">Status</div>
                                                    </div>
                                                    <div class="crmControl">
                                                        <div class="crmContents">
                                                            <div class="crmStatusButtons">
                                                                <div class="crmCurrentStatus">
                                                                    {{ currentTopicStatus.StatusName }}
                                                                </div>
                                                                <div class="crmStatusButton"
                                                                     v-for="action in actionListForStatus"
                                                                     :key="action.StatusID">
                                                                    <div class="crmStatusAction"
                                                                         @click="
                                      changeTopicStatus(
                                        action,
                                        action.SendsNotification
                                      )
                                    ">
                                                                        {{ action.ActionButtonText }}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </DxDrawer>
                            </div>

                            <div class="crmElements" v-if="showNetworkList">
                                <div class="crmWidget">
                                    <NetworkList :topicId="currentTopicId"
                                                 @opendetail="openDetail"></NetworkList>
                                </div>
                            </div>
                            <div v-if="showComment" class="crmElements crmCommentArea">
                                <TopicComment :topicId="currentTopicId"></TopicComment>
                            </div>
                        </div>
                        <!--<div class="crmValidationSummaryBox" v-if="!loadingStatus">
                                        <DxValidationSummary id="crmValidationSummary" ref="validationSummary" />
                                    </div>-->
                        <!-- Neue Felder für historische Versionen -->
                        <div v-if="
                             isHistoric && newVersionFields && newVersionFields.length>
                            0
                            "
                            class="crmElements new-version-fields"
                            >
                            <div class="crmCaption new-fields-header">
                                New Fields Added in Current Version:
                            </div>
                            <div v-for="field in newVersionFields"
                                 :key="field.Name"
                                 class="crmElements added-field">
                                <div class="crmCaption">
                                    {{ field.Caption }}
                                    <span v-if="field.Required" class="crmRequired">*</span>
                                </div>
                                <div class="crmControl added-field-value">
                                    {{ field.CurrentVersionValue }}
                                </div>
                                <!--<div class="added-field-info">
                                                    <small>
                                                        Added at: {{ field.ComparisonTime ? moment(field.ComparisonTime).format('DD.MM.YYYY HH:mm') : 'Unknown' }}
                                                    </small>
                                                </div>-->
                            </div>
                        </div>

                        <!-- Gelöschte Felder für historische Versionen -->
                        <div v-if="
                             isHistoric && deletedVersionFields && deletedVersionFields.length>
                            0
                            "
                            class="crmElements deleted-version-fields"
                            >
                            <div class="crmCaption deleted-fields-header">
                                Fields Deleted in Current Version:
                            </div>
                            <div v-for="field in deletedVersionFields"
                                 :key="field.FieldName"
                                 class="crmElements deleted-field">
                                <div class="crmCaption">
                                    {{ field.Caption }}
                                    <span v-if="field.Required" class="crmRequired">*</span>
                                </div>
                                <div class="crmControl deleted-field-value">
                                    {{ field.PreviousVersionValue }}
                                </div>
                                <div class="deleted-field-info">
                                    <small class="deleted-field-note">
                                        (This field was present in the historical version but has been removed in the current version)
                                    </small>
                                </div>
                            </div>
                        </div>

                        <div class="crmButtons" v-if="!loadingStatus && showStatusInfo">
                            <div class="crmContents">
                                <div class="crmButton">
                                    <DxButton :text="btn.BtnBackToView"
                                              type="default"
                                              icon="fa-regular fa-circle-arrow-left"
                                              :use-submit-behavior="false"
                                              @click="navigateBack($event)" />
                                </div>
                                <div class="crmButton" v-if="!formIsReadOnly">
                                    <DxButton :text="btn.BtnSave"
                                              icon="fa-light fa-floppy-disk"
                                              type="success"
                                              @click="update" />
                                </div>
                                <div class="crmButton"
                                     v-if="topicAccess.Delete && !formIsReadOnly">
                                    <DxButton :text="currentTopicStatus.DeleteButtonText"
                                              :icon="
                                              currentTopicStatus.DeleteButtonIcon &&
                                              currentTopicStatus.DeleteButtonIcon.length>
                                        0
                                        ? currentTopicStatus.DeleteButtonIcon
                                        : 'fa-light fa-trash'
                                        "
                                        type="danger"
                                        @click="deleteTopic"
                                        />
                                </div>
                                <div v-if="showStatusActions" style="display: contents">
                                    <div class="crmButton crmStatusSubmitButtons"
                                         v-for="action in actionListForStatus"
                                         :key="action.StatusID">
                                        <DxButton :text="action.ActionButtonText"
                                                  type="success"
                                                  :icon="
                                                  action.ActionButtonIcon &&
                                                  action.ActionButtonIcon.length>
                                            0
                                            ? action.ActionButtonIcon
                                            : 'fa-light fa-plus'
                                            "
                                            @click="changeTopicStatus(action)"
                                            />
                                    </div>
                                </div>
                                <div v-if="showLinkStatusActions" style="display: contents">
                                    <div v-for="action in topicLinkActionList"
                                         :key="action.TltId"
                                         class="crmButton"
                                         style="display: contents">
                                        <div v-if="action.LinkCount < action.TltMax">
                                            <DxButton :text="action.TltCreateButtonText"
                                                      :icon="
                                                      action.ActionButtonIcon &&
                                                      action.ActionButtonIcon.length>
                                                0
                                                ? action.ActionButtonIcon
                                                : 'fa-light fa-plus'
                                                "
                                                @click="addTopicLink(action)"
                                                type="success"
                                                />
                                        </div>
                                    </div>
                                </div>
                                <div class=" " v-if="isHistoric &&
                                accessList._300912">
                                    <DxButton text="Restore this Version"
                                              icon="fa fa-undo-alt"
                                              type="danger"
                                              @click="restoreVersion" />
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </DxValidationGroup>
</template>

<script>
    import _ from "lodash";
    import moment from "moment";
    import TopicLinkSelectList from "./widgets/TopicLinkSelectList.vue";
    import NetworkChartForSingleRecord from "@/views/widgets/NetworkChartForSingleRecord";
    import LoadingSpinner from "@/views/widgets/LoadingSpinner";
    import TopicEntryWidget from "@/views/widgets/TopicEntryWidget";
    import ChangeTopicStatusPopup from "@/views/widgets/ChangeTopicStatusPopup";
    import { DxTooltip } from "devextreme-vue/tooltip";
    import { DxAccordion } from "devextreme-vue/accordion";
    import { DxNumberBox } from "devextreme-vue/number-box";
    import { DxTagBox } from "devextreme-vue/tag-box";
    import { DxDateBox } from "devextreme-vue/date-box";
    import { DxCheckBox } from "devextreme-vue/check-box";
    import { DxFileUploader } from "devextreme-vue/file-uploader";
    import { DxButton } from "devextreme-vue/button";
    import { DxSlider, DxLabel } from "devextreme-vue/slider";
    import { DxTextBox } from "devextreme-vue/text-box";
    import { DxTreeView } from "devextreme-vue/tree-view";
    import { DxTextArea } from "devextreme-vue/text-area";
    import { DxPopup } from "devextreme-vue/popup";
    import { DxSelectBox } from "devextreme-vue/select-box";
    import {
        DxHtmlEditor,
        DxItem,
        DxMediaResizing,
        DxToolbar,
    } from "devextreme-vue/html-editor";
    import { DxLoadPanel } from "devextreme-vue/load-panel";
    import TopicVoting from "@/views/TopicVoting";
    import TopicPublicVoting from "@/views/TopicPublicVoting";
    import { findAndDeselect } from "@/views/helper/findAndDeselect.js";
    import NetworkList from "@/views/widgets/NetworkList";
    import TopicComment from "@/views/TopicComment";
    import { htmlToText } from "html-to-text";
    import DxValidationGroup from "devextreme-vue/validation-group";
    import { alert, confirm } from "devextreme/ui/dialog";
    import { DxScrollView } from "devextreme-vue/scroll-view";
    import myUpload from "vue-image-crop-upload";
    import DxDrawer from "devextreme-vue/drawer";
    import {
        DxDataGrid,
        DxExport,
        DxColumn,
        DxSelection,
        DxScrolling,
        DxPaging,
        DxPager,
    } from "devextreme-vue/data-grid";
    import { Workbook } from "exceljs";
    import axios from "axios";
    import { exportDataGrid as exportDataGridToPdf } from "devextreme/pdf_exporter";
    import { exportDataGrid } from "devextreme/excel_exporter";
    import { saveAs } from "file-saver-es";
    import { jsPDF } from "jspdf";
    import {
        DxValidator,
        DxRequiredRule,
        DxCustomRule,
        DxRangeRule,
    } from "devextreme-vue/validator";

    const baseUri = "WebApi.asmx/api/applicationService";

    // --- TTY enumeration (from nodeConfig.json) ---
    // 7: Project Output
    // 8: Stakeholder Requirements
    // 9: Stakeholder Group
    // 10: Satellite Missions
    // 15: Policies
    // 16: Stakeholders
    // 24: Projects
    const TTY = Object.freeze({
        PROJECT_OUTPUT: 7,
        STAKEHOLDER_REQUIREMENTS: 8,
        STAKEHOLDER_GROUP: 9,
        SATELLITE_MISSIONS: 10,
        POLICIES: 15,
        STAKEHOLDERS: 16,
        PROJECTS: 24,
    });

    // Removed legacy networkFilter mapping (edge-driven rules now authoritative)

    // Edge-driven expansion rules used by NetworkChartForSingleRecord
    // New explicit contract: level1.edgeTltIds required; level2 is a mapping { [firstLevelTtyId:number]: number[] }
    // Missing or empty level2 mapping => no second-level edges
    const EDGE_RULES = Object.freeze({
        /* Policy page
                 Level1: policies (6), projects (3), stakeholder groups (35), stakeholders (10 filtered by role)
                 Level2: additional policies via policies/projects/groups (6,3,35) */
        [TTY.POLICIES]: {
            level1: {
                edgeTltIds: [6, 3, 35, 10],
                stakeholderRole: { edgeTltIds: [10], allowedLitValue1: [1, 2] },
            },
            // Previously global [6,3,35]; now specify by first-level type
            level2: {
                [TTY.POLICIES]: [6],
                [TTY.PROJECTS]: [3],
                [TTY.STAKEHOLDER_GROUP]: [35],
            },
        },
        /* Stakeholder Group page
                 Level1: policies (35), stakeholders (8), projects (34), stakeholder groups (33)
                 Level2: projects via policies/stakeholders (3,4), other stakeholder groups (11) & via shared stakeholders (8) */
        [TTY.STAKEHOLDER_GROUP]: {
            level1: { edgeTltIds: [35, 8, 34, 33] },
            level2: {
                [TTY.POLICIES]: [3, 35],
                [TTY.STAKEHOLDERS]: [4, 8],
                [TTY.PROJECTS]: [5, 34],
            },
        },
        /* Stakeholder page
                 Level1: policies (10), projects (4), stakeholder groups (8)
                 Level2: policies & projects via stakeholder groups (35,34) and projects via policies (3) */
        [TTY.STAKEHOLDERS]: {
            level1: { edgeTltIds: [10, 4, 8] },
            level2: {
                [TTY.STAKEHOLDER_GROUP]: [35, 34],
                [TTY.POLICIES]: [3],
            },
        },
        /* Project page
                 Level1: policies (3), projects (5), stakeholders (4), stakeholder groups (34)
                 Level2: policies via stakeholders/groups (10,35), stakeholders & groups via projects (4,34), projects via policies/stakeholders/groups (3) */
        [TTY.PROJECTS]: {
            level1: { edgeTltIds: [3, 5, 4, 34] },
            level2: {
                [TTY.POLICIES]: [3],
                [TTY.PROJECTS]: [4, 34],
                [TTY.STAKEHOLDERS]: [10, 4],
                [TTY.STAKEHOLDER_GROUP]: [35, 34],
            },
        },
        /* Satellite Missions page
                 Level1: policies (27), projects (26), project outputs (25)
                 Level2: stakeholder groups & projects/policies associations (35,34) and stakeholders via policies/projects (10,4) */
        [TTY.SATELLITE_MISSIONS]: {
            level1: { edgeTltIds: [27, 26, 25] },
            level2: {
                [TTY.POLICIES]: [35, 10],
                [TTY.PROJECTS]: [34, 4],
            },
        },
        /* Stakeholder Requirements page (not specified in current requirements) – empty => allow none (no expansion) */
        [TTY.STAKEHOLDER_REQUIREMENTS]: { level1: { edgeTltIds: [] }, level2: {} },
        /* Project Output page
                 Level 1: projects, stakeholders, stakeholder groups, policies
                 Level 2: policies via stakeholders (10) or groups (35); stakeholders (4) and groups (34) via projects; projects via policies (3),stakeholders (4) or groups (34) */
        [TTY.PROJECT_OUTPUT]: {
            level1: { edgeTltIds: [9, 15, 14, 12] },
            level2: {
                [TTY.STAKEHOLDER_GROUP]: [35, 34],
                [TTY.STAKEHOLDERS]: [10, 4],
                [TTY.POLICIES]: [3],
                [TTY.PROJECTS]: [4, 34],
            },
        },
    });

    // Order of link groups per center (all numeric now).
    // If a TtyId in the data is missing here it will be hidden.
    const linkGroupOrderByTtyId = {
        [TTY.POLICIES]: [
            TTY.STAKEHOLDER_REQUIREMENTS,
            TTY.STAKEHOLDERS,
            TTY.STAKEHOLDER_GROUP,
            TTY.PROJECTS,
            TTY.POLICIES,
        ],
        [TTY.STAKEHOLDER_GROUP]: [
            TTY.STAKEHOLDERS,
            TTY.STAKEHOLDER_GROUP,
            TTY.STAKEHOLDER_REQUIREMENTS,
            TTY.POLICIES,
            TTY.PROJECTS,
        ],
        [TTY.STAKEHOLDERS]: [
            TTY.STAKEHOLDER_REQUIREMENTS,
            TTY.PROJECTS,
            TTY.POLICIES,
            TTY.STAKEHOLDER_GROUP,
            TTY.STAKEHOLDERS,
            TTY.SATELLITE_MISSIONS,
            TTY.PROJECT_OUTPUT,
        ],
        [TTY.PROJECTS]: [
            TTY.STAKEHOLDER_REQUIREMENTS,
            TTY.STAKEHOLDER_GROUP,
            TTY.STAKEHOLDERS,
            TTY.POLICIES,
            TTY.PROJECTS,
            TTY.SATELLITE_MISSIONS,
        ],
        [TTY.STAKEHOLDER_REQUIREMENTS]: [
            TTY.POLICIES,
            TTY.STAKEHOLDERS,
            TTY.STAKEHOLDER_GROUP,
            TTY.PROJECTS,
            TTY.SATELLITE_MISSIONS,
            TTY.STAKEHOLDER_REQUIREMENTS,
        ],
        [TTY.SATELLITE_MISSIONS]: [
            TTY.PROJECTS,
            TTY.PROJECT_OUTPUT,
            TTY.POLICIES,
            TTY.STAKEHOLDER_REQUIREMENTS,
        ],
        [TTY.PROJECT_OUTPUT]: [
            TTY.STAKEHOLDER_REQUIREMENTS,
            TTY.STAKEHOLDER_GROUP,
            TTY.STAKEHOLDERS,
            TTY.POLICIES,
            TTY.PROJECTS,
            TTY.SATELLITE_MISSIONS,
        ],
    };

    // Non-collapsible groups (by numeric TtyId of the group) per center TtyId.
    const nonCollapsibleGroupTtyIdsByCenter = {
        [TTY.POLICIES]: [],
        [TTY.PROJECTS]: [],
        [TTY.STAKEHOLDERS]: [],
        [TTY.STAKEHOLDER_GROUP]: [],
        [TTY.SATELLITE_MISSIONS]: [],
        [TTY.STAKEHOLDER_REQUIREMENTS]: [],
        [TTY.PROJECT_OUTPUT]: [],
    };

    export default {
        name: "topicEntry",
        components: {
            DxAccordion,
            DxTooltip,
            DxButton,
            DxTextBox,
            DxTextArea,
            DxHtmlEditor,
            DxItem,
            DxMediaResizing,
            DxToolbar,
            TopicPublicVoting,
            DxLoadPanel,
            DxCustomRule,
            DxScrolling,
            DxPaging,
            DxPager,
            LoadingSpinner,
            DxTreeView,
            DxFileUploader,
            DxValidator,
            DxCheckBox,
            DxTagBox,
            DxRequiredRule,
            DxValidationGroup,
            DxRangeRule,
            DxDataGrid,
            DxColumn,
            DxExport,
            DxSelection,
            DxDrawer,
            NetworkChartForSingleRecord,
            ChangeTopicStatusPopup,
            "my-upload": myUpload,
            DxPopup,
            DxScrollView,
            TopicLinkSelectList,
            TopicEntryWidget,
            TopicVoting,
            DxSlider,
            DxSelectBox,
            DxNumberBox,
            DxDateBox,
            DxLabel,
            TopicComment,
            NetworkList,
        },
        data() {
            return {
                changedOn: "",
                versionList: [],
                loadingLinkListVisible: true,
                selectedRevealMode: "expand",
                selectedPosition: "top",
                selectedOpenMode: "shrink",
                openState: true,
                openStateGrid: false,
                showUserSelection: false,
                showCropper: false,
                chartKey: 0,
                expertsListForGroup: [],
                selectedExperts: [],
                pageSizes: [10, 15, 30],
                cropperParams: { token: "12321", name: "avatar" },
                cropperHeader: { smail: "*_~" },
                titleValue: {},
                column: {
                    ColStatus: this.$LanguageProvider.GetResource(
                        "ColStatus",
                        "Caption",
                        "Status"
                    ),
                    ColAiFields: this.$LanguageProvider.GetResource(
                        "ColAiFields",
                        "Caption",
                        "AI Fields"
                    ),
                    ColAiField1: this.$LanguageProvider.GetResource(
                        "ColAiField1",
                        "Caption",
                        "AI Field 1"
                    ),
                    ColAiField2: this.$LanguageProvider.GetResource(
                        "ColAiField2",
                        "Caption",
                        "AI Field 2"
                    ),
                    ColAiField3: this.$LanguageProvider.GetResource(
                        "ColAiField3",
                        "Caption",
                        "AI Field 3"
                    ),
                    Colname: this.$LanguageProvider.GetResource(
                        "Colname",
                        "Caption",
                        "Name"
                    ),
                    ColSalCaptionEN: this.$LanguageProvider.GetResource(
                        "ColSalCaptionEN",
                        "Caption",
                        "Gender"
                    ),
                    ColUsrBirthDay: this.$LanguageProvider.GetResource(
                        "ColUsrBirthDay",
                        "Caption",
                        "Birthday"
                    ),
                    ColRol: this.$LanguageProvider.GetResource(
                        "ColRol",
                        "Caption",
                        "Membership"
                    ),
                    ColCity: this.$LanguageProvider.GetResource(
                        "ColCity",
                        "Caption",
                        "City"
                    ),
                    ColUsrEMailOwner: this.$LanguageProvider.GetResource(
                        "ColEmail",
                        "Caption",
                        "Email"
                    ),
                    ColCurtStatus: this.$LanguageProvider.GetResource(
                        "ColCurtStatus",
                        "Caption",
                        "Current status"
                    ),
                    ColUni: this.$LanguageProvider.GetResource(
                        "ColUni",
                        "Caption",
                        "University/Research Center"
                    ),
                    ColFoR: this.$LanguageProvider.GetResource(
                        "ColFoR",
                        "Caption",
                        "Field of research"
                    ),
                    ColType: this.$LanguageProvider.GetResource(
                        "ColType",
                        "Caption",
                        "Type"
                    ),
                },
                cropperLanguageExtend: {
                    hint: "Click or drag the file here to upload",
                    loading: "Uploading…",
                    noSupported:
                        "Browser is not supported, please use IE10+ or other browsers",
                    success: "Upload success",
                    fail: "Upload failed",
                    preview: "Preview",
                    btn: {
                        off: "Cancel",
                        close: "Close",
                        back: "Back",
                        save: "Save",
                    },
                    error: {
                        onlyImg: "Image only",
                        outOfSize: "Image exceeds size limit: ",
                        lowestPx: "Image's size is too low. Expected at least: ",
                    },
                },
                topicId: 0,
                isHistoryNavigating: false,
                hover: false,
                popup: {
                    visible: false,
                    template: "",
                    title: "",
                    message: "",
                    hasChangeNotification: false,
                    showAssigneeSelection: false,
                    showExpertsSelection: false,
                    expertsGrpId: 0,
                    mailText: "",
                    multiselect: false,
                    action: {},
                },
                actionTopicId: 0,
                actionCategoryId: 0,
                actionTlsId: 0,
                actionStatusId: 0,
                loading: false,
                limitMessageShown: false,
                moment: moment,
                submitAction: null,
                selectedVersion: null,
                btn: {
                    BtnBackToView: this.$LanguageProvider.GetResource(
                        "BtnBackToView",
                        "Caption",
                        "Back"
                    ),
                    BtnBack: this.$LanguageProvider.GetResource(
                        "BtnBack",
                        "Caption",
                        "Back"
                    ),
                    BtnSave: this.$LanguageProvider.GetResource(
                        "BtnSave",
                        "Caption",
                        "Save"
                    ),
                    BtnDeepLink: this.$LanguageProvider.GetResource(
                        "BtnDeepLink",
                        "Caption",
                        "Get Deep Link"
                    ),
                    BtnDelete: this.$LanguageProvider.GetResource(
                        "BtnDelete",
                        "Caption",
                        "Delete"
                    ),
                    BtnSelect: this.$LanguageProvider.GetResource(
                        "BtnSelect",
                        "Caption",
                        "Select"
                    ),
                    BtnSelectFile: this.$LanguageProvider.GetResource(
                        "BtnSelectFile",
                        "Caption",
                        "Select file"
                    ),
                    BtnSubmit: this.$LanguageProvider.GetResource(
                        "BtnSubmit",
                        "Caption",
                        "Submit"
                    ),
                    BtnDownloadPDF: this.$LanguageProvider.GetResource(
                        "BtnDownloadPDF",
                        "Caption",
                        "Download PDF"
                    ),
                    BtnDownloadDocx: this.$LanguageProvider.GetResource(
                        "BtnDownloadDocx",
                        "Caption",
                        "Download Docx"
                    )
                },
                accordionOpenItems: [],
            };
        },
        watch: {
            currentTopicId(topicId) {
                this.loadingLinkListVisible = true;
                this.$store
                    .dispatch("getTopicLinkListEx", { topicId, withPhoto: false })
                    .then(() => {
                        this.loadingLinkListVisible = false;
                    });
            },
            mappedGroups: {
                handler(val) {
                    // prune open items no longer present
                    const captions = new Set(
                        val.collapsibleGroups.map((g) => g.rawCaption)
                    );
                    this.accordionOpenItems = this.accordionOpenItems.filter((i) =>
                        captions.has(i.rawCaption)
                    );
                },
                deep: true,
            },
        },
        computed: {
            versionStatus() {
                return this.$store.state.applicationStore.versionStatus;
            },
            currentStatus() {
                return this.$store.state.applicationStore.currentStatus;
            },

            newVersionFields() {
                // Filter FormElements that have PreviousVersionIsNull = true
                return (
                    this.modulTypeAttributeList.filter(
                        (element) => element.PreviousVersionIsNull === true
                    ) || []
                );
            },
            deletedVersionFields() {
                // Filter version changes that have ChangeType = "Deleted"
                return (
                    this.modulTypeAttributeList.filter(
                        (element) => element.ChangeType === "Deleted"
                    ) || []
                );
            },
            edgeExpansionRules() {
                return EDGE_RULES[this.topicTypeId] || null;
            },
            // Flattens & groups; attaches groupTtyId for numeric ordering.
            orderedLinkGroups() {
                if (!this.topicLinkList?.length) return [];
                const orderArray = linkGroupOrderByTtyId[this.topicTypeId] || [];

                const flat = [];
                this.topicLinkList.forEach((tl) => {
                    tl.grouped.forEach((grp) => {
                        if (!grp.length) return;
                        const firstTopic = grp[0];
                        const groupTtyId = firstTopic.TtyId; // assume homogeneous per group
                        flat.push({
                            groupTtyId,
                            grp,
                            rawCaption: grp.key.Caption2,
                        });
                    });
                });

                // Do NOT remove groups not in orderArray; instead, sort them after the ordered ones
                flat.sort((a, b) => {
                    const ia = orderArray.indexOf(a.groupTtyId);
                    const ib = orderArray.indexOf(b.groupTtyId);
                    // Types in orderArray come first, in order; others come after, sorted alphabetically
                    if (ia >= 0 && ib >= 0) {
                        return ia - ib;
                    } else if (ia >= 0) {
                        return -1;
                    } else if (ib >= 0) {
                        return 1;
                    } else {
                        // Both not in orderArray: sort alphabetically by caption
                        return a.rawCaption.localeCompare(b.rawCaption);
                    }
                });
                return flat;
            },

            mappedGroups() {
                const staticCfg =
                    nonCollapsibleGroupTtyIdsByCenter[this.topicTypeId] || [];
                const staticGroups = [];
                const collapsibleGroups = [];
                this.orderedLinkGroups.forEach((g) => {
                    if (staticCfg.includes(g.groupTtyId)) staticGroups.push(g);
                    else collapsibleGroups.push(g);
                });
                return { staticGroups, collapsibleGroups };
            },
            showNetworkChart() {
                debugger;
                if (this.topicTypeId === 8) return false; // hide for Requirements
                return this.currentTopicStatus?.StgId == 15; // only if Published
            },
            accessList() {
                return this.$store.state.accessStore.accessList;
            },
            actionTopicIds() {
                return this.topicLinksForLinking
                    .filter((m) => m.selected == true)
                    .map((m) => m.TopicId);
            },
            userListForGroup() {
                return this.$store.state.userStore.userListForGroup;
            },
            topicLinksForLinking() {
                var res = this.$store.state.topicLinkStore.topicLinksForLinking;
                res.forEach((m) => (m.selected = false));
                return res;
            },
            showAsFullscreen() {
                return window.innerWidth < 600;
            },
            topicAccess: function () {
                return this.$store.state.topicStore.topicAccess;
            },
            topicLinkList() {
                const linkLists = this.$store.state.topicLinkStore.topicLinkList || [];

                // Liefert eine neue Liste mit berechneter 'grouped'-Eigenschaft ohne den Store zu mutieren
                return linkLists.map((list) => {
                    const topics = Array.isArray(list.Topics) ? list.Topics : [];
                    const groupedObj = _.groupBy(topics, (m) => {
                        const addGrp =
                            m.TtyId === 16 && m.TdgList002Name > ""
                                ? " " + m.TdgList002Name
                                : "";
                        const heading = `${m.TtyName || ""}${addGrp}`.trim();
                        return JSON.stringify({ Caption2: heading });
                    });

                    const statusOrder = (stgId) =>
                        stgId === 15
                            ? 0
                            : stgId === 10
                                ? 10
                                : stgId === 12
                                    ? 12
                                    : stgId === 20
                                        ? 20
                                        : 5;

                    const grouped = Object.keys(groupedObj).map((key) => {
                        const arr = groupedObj[key];
                        arr.sort((a, b) => statusOrder(a.StgId) - statusOrder(b.StgId));
                        arr.key = JSON.parse(key);
                        return arr;
                    });

                    // Neues Objekt zurückgeben, Original aus dem Store unverändert lassen
                    return { ...list, grouped };
                });
            },

            topicLinkList1() {
                return this.$store.state.topicLinkStore.topicLinkList;
            },
            topicLinkListHasStgPublished() {
                var result = this.$store.state.topicLinkStore.topicLinkList;
                var found = false;
                result.forEach((topic) => {
                    if (topic.Topics.filter((m) => m.StgId == 15).length > 0) found = true;
                });
                return found;
            },
            topicLinkActionList() {
                return this.$store.state.topicLinkStore.topicLinkActionList;
            },
            actionListForStatus() {
                var result = this.$store.state.statusStore.actionListForStatus;
                return result;
            },
            currentTopicStatus() {
                var result = this.$store.state.statusStore.currentTopicStatus;
                return result;
            },
            modulTypeAttributeList() {
                var result = this.$store.state.applicationStore.modulTypeAttributeList;
                var self = this;
                if (this.formIsReadOnly && result && result.length > 0) {
                    result.forEach((m) => {
                        if (m.AtyId == 2 && m.Value && m.Value.length > 1500)
                            m.className = "crmBreakInside";
                        else m.className = "notCrmBreakInside";
                    });
                    var first = result.find(
                        (m) => m.AtyId == 1 || m.AtyId == 2 || m.AtyId == 23
                    );
                    if (first && first.AtrId == 18) {
                        self.titleValue = first;
                        result = result.filter((m) => m != first);
                    }
                }

                if (result && result.length > 0 && result[0].groupData == undefined) {
                    result.forEach((m) => {
                        m.ShowSelectionPopup = false;
                        m.groupData = this.processGrouped(m);
                        var expand = m.groupData.length < 5;
                        if (expand) {
                            m.groupData.forEach((g) => (g.expand = true));
                        }
                    });
                }
                return result;
            },
            entryTitle() {
                if (this.formIsReadOnly) {
                    var result = this.$store.state.applicationStore.modulTypeAttributeList;
                    var first = result.find(
                        //(m) => m.AtyId == 1 || m.AtyId == 2 || m.AtyId == 23
                        (m) => m.AtrId == 18
                    );
                    return first ? first.Value : "";
                } else {
                    return "";
                }
            },
            record() {
                var obj = {};
                this.modulTypeAttributeList.forEach((m) => {
                    obj.__defineGetter__(m.Name, () => m.Value);
                    if (m.AtyId == 21) {
                        obj.__defineGetter__(m.Name + "_Text", () => {
                            if (m.listItems && m.listItems[0] && m.listItems[0].items) {
                                return m.listItems[0].items
                                    .filter((e) => e.selected)
                                    .map((e) => e.text)
                                    .join(", ");
                            }
                            return "";
                        });
                    }
                    if (m.AtyId == 19) {
                        obj.__defineGetter__(m.Name + "_PictureCount", () => {
                            if (m.Value && m.Value[0]) {
                                return true;
                            }
                            return false;
                        });
                    } else {
                        obj.__defineGetter__(m.Name + "_Text", () =>
                            m.SelectedText ? m.SelectedText : ""
                        );
                    }
                    obj.__defineGetter__(m.Name + "_Keys", () => m.SelectedKeys);
                });

                return obj;
            },

            loadingStatus() {
                return this.$store.getters.loadingStatus;
            },
            formIsReadOnly() {
                return (
                    this.readOnly ||
                    this.$store.state.applicationStore.formIsReadOnly ||
                    this.topicAccess.Update != true
                );
            },
            showVoting() {
                return this.$store.state.applicationStore.showVoting;
            },
            allowPublicVoting() {
                return this.$store.state.applicationStore.allowPublicVoting;
            },
            publicVotingRtgId() {
                return this.$store.state.applicationStore.publicVotingRtgId;
            },
            rtgId() {
                return this.$store.state.applicationStore.rtgId;
            },
            ttyInfo() {
                var result = this.$store.state.applicationStore.ttyInfo;
                result.TtyDescription = htmlToText(result.TtyDescription);
                return result;
            },
            showComment() {
                // Regression fix: restore dynamic gating for TopicComment component.
                // Render comments if the user has at least one public OR internal comment permission.
                // Public: read(300511) edit(300512) create(300514) delete(300518)
                // Internal: read(300581) edit(300582) create(300584) delete(300588)
                //Internal: Version
                const a = this.accessList || {};
                return !!(a._300511 || a._300512 || a._300514 || a._300518 ||
                    a._300581 || a._300582 || a._300584 || a._300588 || a._300911);
            },
            showNavigator() {
                return this.topicIdList && this.topicIdList.length > 1;
            },
            topicIdList() {
                return this.$store.state.applicationStore.topicIdList;
            },
            topicTypeId() {
                return this.$store.state.applicationStore.ttyId;
            },
            showAmbassador() {
                return this.$store.state.applicationStore.ttyId == 23;
            },
            topicTypeDetail() {
                return this.$store.state.topicTypeStore.topicTypeDetail;
            },
            currentTopicId() {
                return this.$store.state.applicationStore.currentTopicId;
            },
            topicInfo() {
                return this.$store.state.applicationStore.topicInfo;
            },
            pageTitle() {
                switch (this.topicTypeId) {
                    case 23:
                        return this.currentTopicStatus.StgId == 15 ? "Member" : "Applicant";
                    default:
                        return this.ttyInfo.TtyName;
                }
            },
            args() {
                let uri = window.location.search.substring(1);
                let params = new URLSearchParams(uri);
                return params.get("args");
            },
            index() {
                return this.topicIdList.indexOf(this.currentTopicId);
            },
            hasFirst() {
                return this.index > 0;
            },
            hasPrevious() {
                return this.index > 0;
            },
            hasNext() {
                return this.topicIdList.length > this.index + 1;
            },
            hasLast() {
                return this.topicIdList.length > this.index + 1;
            },
            //topicsInSuchfeld() {
            //    var list = this.$store.state.iconListStore.topicCardList
            //    var result = list.filter(m => (this.rouId == 0 || this.rouId == m.RouId) &&
            //        (this.suchfeldId == 0 || (m.Suchfelder.includes(this.suchfeldId))))
            //    return result
            //},
        },
        mounted() {
            const uri = window.location.search.substring(1);
            const params = new URLSearchParams(uri);
            this.topicId = params.get("topicId"); // evtl. null beim ersten Aufruf
            this.loading = true;
            Promise.all([
                this.$store.dispatch("GetGenericFormData", { args: this.args, topicId: this.topicId }),
                this.$store.dispatch("getTopicAccess", { args: this.args, topicId: this.topicId }),
                this.$store.dispatch("getActionListByWorkflow", { args: this.args, topicId: this.topicId }),
                this.$store.dispatch("getTopicLinkActionByStatus", { args: this.args, topicId: this.topicId }),
                // Preload access flags used across the page, including comment permissions used by showComment
                this.$store.dispatch("getAccessList", {
                    tokenList: [
                        "300762", "300421", "300911", "300912",
                        // Public comments: read, edit, create, delete
                        "300511", "300512", "300514", "300518",
                        // Internal comments: read, edit, create, delete
                        "300581", "300582", "300584", "300588"
                    ]
                })
            ]).then(() => {
                // Falls initial keine topicId in der URL war -> aus Store setzen
                if (!this.topicId && this.currentTopicId) {
                    this.topicId = this.currentTopicId;
                }
                this.replaceInitialHistoryState();
                window.addEventListener("popstate", this.handlePopState);
                this.getTopicVersions();
                this.loading = false;
            });
            const stored = sessionStorage.getItem("mappingAccordionOpen");
            if (stored) {
                try {
                    const rawCaptions = JSON.parse(stored);
                    // map back to current objects
                    this.accordionOpenItems = this.mappedGroups.collapsibleGroups.filter(
                        (g) => rawCaptions.includes(g.rawCaption)
                    );
                } catch {
                    /* ignore */
                }
            }
        },
        beforeUnmount() {
            window.removeEventListener("popstate", this.handlePopState);
        },
        created() { },
        methods: {
            compareAndHighlight(currentValue, previousValue) {
                // Prüfe auf "same as current Version" Text
                if (previousValue === "same as current Version" ||
                    currentValue === "same as current Version") {
                    return currentValue || previousValue || '';
                }

                if (currentValue === previousValue) {
                    return currentValue || '';
                }
                
                if (!currentValue) return '';
                if (!previousValue) previousValue = '';

                const currentWords = currentValue.split(' ');
                const previousWords = previousValue.split(' ');

                return currentWords.map(word => {
                    if (!previousWords.includes(word)) {
                        return `<span style="color: red; font-weight:bold">${word}</span>`;
                    }
                    return word;
                }).join(' ');
            },
            downloadPdfSingle() {
                if (!this.currentTopicId) return;
                const keys = encodeURIComponent(JSON.stringify([this.currentTopicId]));
                const arg = "?keys=" + keys + "&format=individualpdf";
                window.open("BulkDownloadPDF.aspx" + arg, "_blank");
            },
            downloadDocxSingle() {
                if (!this.currentTopicId) return;
                const keys = encodeURIComponent(JSON.stringify([this.currentTopicId]));
                const arg = "?keys=" + keys + "&format=individualdocx";
                window.open("BulkDownloadPDF.aspx" + arg, "_blank");
            },
            onAccordionSelectionChanged() {
                sessionStorage.setItem(
                    "mappingAccordionOpen",
                    JSON.stringify(this.accordionOpenItems.map((i) => i.rawCaption))
                );
            },
            updateChart() {
                this.chartKey += 1;
            },
            selectedVersionChanged(e) {
                this.selectedVersionInfo = this.selectedVersion
                    ? this.versionList.find((m) => m.TimeStartUtc === this.selectedVersion)
                    : {};
                this.isHistoric =
                    this.selectedVersionInfo && this.selectedVersionInfo.Version > "";
                
                return this.$store.dispatch("GetGenericFormDataGrouped", {
                    args: this.args,
                    topicId: this.topicId,
                    version: e.value,
                }).then(() => {
                    return this.$store.dispatch("GetTopicVersionChanges", {
                        args: this.args,
                        topicId: this.topicId,
                        version: e.value,
                    });
                }).then(() => {
                    this.loading = false;
                });
            },
            restoreVersion() {
                confirm(
                    "Do you really want to restore this version?",
                    "Restore Version"
                ).done((ok) => {
                    debugger;
                    if (ok) {
                        this.update();
                        this.selectedVersion = null;
                    }
                });
            },
            getTopicVersions() {
                debugger;
                return axios
                    .get(baseUri + "/GetTopicVersions", {
                        params: { args: this.args, topicId: this.topicId },
                    })
                    .then((res) => {
                        if (res.data.success) {
                            this.versionList = res.data.list.map((m) => {
                                return {
                                    Version:
                                        "#" +
                                        m.Version +
                                        " of " +
                                        moment(m.TimeStart).format("DD/MM/YYYY HH:mm:ss") +
                                        " by " +
                                        m.ChangedBy,
                                    TimeStartUtc: m.TimeStartUtc,
                                };
                            });
                            this.changedOn = this.versionList[0]?.TimeStartUtc;
                        } else {
                            alert("Action failed due to an error");
                        }
                        return res;
                    });
            },
            replaceInitialHistoryState() {
                const params = new URLSearchParams(window.location.search);
                const id = this.topicId || this.currentTopicId;
                if (id) {
                    params.set("topicId", id);
                    const newUrl = `${window.location.pathname}?${params.toString()}`;
                    window.history.replaceState({ topicId: id }, "", newUrl);
                }
            },
            pushHistory(topicId) {
                const params = new URLSearchParams(window.location.search);
                params.set("topicId", topicId);
                const newUrl = `${window.location.pathname}?${params.toString()}`;
                window.history.pushState({ topicId }, "", newUrl);
            },
            handlePopState(e) {
                if (e.state && e.state.topicId) {
                    const targetId = e.state.topicId;
                    if (targetId && targetId !== this.topicId) {
                        this.isHistoryNavigating = true;
                        this.navigateToTopic(targetId, false).finally(
                            () => (this.isHistoryNavigating = false)
                        );
                    }
                }
            },
            navigateToTopic(topicId, addHistory = true) {
                if (!topicId || topicId === this.topicId) return Promise.resolve();
                this.topicId = topicId;
                this.loading = true;
                this.loadingLinkListVisible = true;

                const p1 = this.$store
                    .dispatch("getTopicLinkListEx", { topicId, withPhoto: false })
                    .then(() => {
                        this.loadingLinkListVisible = false;
                    });

                const p2 = Promise.all([
                    this.$store.dispatch("GetGenericFormData", {
                        args: this.args,
                        topicId,
                    }),
                    this.$store.dispatch("getTopicAccess", { args: this.args, topicId }),
                    this.$store.dispatch("getActionListByWorkflow", {
                        args: this.args,
                        topicId,
                    }),
                ]).then(() => {
                    this.loading = false;
                    if (addHistory && !this.isHistoryNavigating) {
                        this.pushHistory(topicId);
                    }
                });

                return Promise.all([p1, p2]);
            },
            navigateBack() {
                if (window.history.length > 1) {
                    window.history.back();
                } else {
                    // Fallback auf altes Verhalten
                    window.location.href =
                        window.location.pathname +
                        (this.args ? `?action=back&args=${this.args}` : "");
                }
            },
            concatText(topic, mutliSelect, text1, text2) {
                //console.log("concatText", topic, mutliSelect, text1, text2)

                //TODO: find a cleaner way to handle flipping text2 value for tlt 6 (policy-policy)
                if (topic.TltId == 6 && text2 > "") {
                    if (topic.IsReversed) {
                        text2 = text2.replace("1", "mandated by");
                        text2 = text2.replace("2", "mandating");
                    } else {
                        text2 = text2.replace("1", "mandating");
                        text2 = text2.replace("2", "mandated by");
                    }
                    text2 = text2.replace("Both", "related to");
                }

                var array = [];
                if (mutliSelect) {
                    var txtItems = mutliSelect.filter((m) => m > "");
                    if (txtItems.length > 0) {
                        array.push(mutliSelect);
                    }
                }
                if (text1 > "") {
                    array.push(text1);
                }
                if (text2 > "") {
                    array.push(text2);
                }
                return array.join(" | ");
            },

            onExporting(e) {
                if (e.format === "pdf") {
                    const doc = new jsPDF();
                    exportDataGridToPdf({
                        jsPDFDocument: doc,
                        component: e.component,
                        indent: 5,
                    }).then(() => {
                        if (this.titleValue) doc.save(this.titleValue.Value);
                        else doc.save("Report.pdf");
                    });
                }
                if (e.format === "xlsx") {
                    const workbook = new Workbook();
                    workbook.title = "Report";
                    if (this.titleValue) workbook.title = this.titleValue.Value;

                    const worksheet = workbook.addWorksheet("Attendees");
                    exportDataGrid({
                        component: e.component,
                        worksheet: worksheet,
                    }).then(function () {
                        workbook.xlsx.writeBuffer().then(function (buffer) {
                            saveAs(
                                new Blob([buffer], { type: "application/octet-stream" }),
                                workbook.title + ".xlsx"
                            );
                        });
                    });
                }
            },
            customizeText(cellInfo) {
                return cellInfo.value.replace(/<\/?[^>]+(>|$)/g, "");
            },
            topicEntryWidgetChanged: function () {
                this.loading = true;
                this.$store
                    .dispatch("getTopicLinkListEx", {
                        topicId: this.currentTopicId,
                        withPhoto: false,
                    })
                    .then(() => {
                        this.loading = false;
                        this.updateChart();
                    });
            },
            popupCancel: function () {
                this.popup.visible = false;
            },
            openDrawer: function () {
                this.openState = !this.openState;
            },
            openDrawerGrid: function () {
                this.openStateGrid = !this.openStateGrid;
            },
            statusChanged: function () {
                return Promise.all([
                    this.$store.dispatch("getActionListByWorkflow", {
                        args: this.args,
                        topicId: this.currentTopicId,
                    }),
                    this.$store.dispatch("getTopicAccess", {
                        args: this.args,
                        topicId: this.currentTopicId,
                    }),
                ]).then(() => {
                    this.loading = false;
                    this.updateChart();
                });
            },
            statusTopicLinkChanged: function () {
                this.loadingLinkListVisible = true;
                return Promise.all([
                    this.$store.dispatch("getTopicLinkListEx", {
                        topicId: this.currentTopicId,
                        withPhoto: false,
                    }),
                ]).then(() => {
                    this.loadingLinkListVisible = false;
                    this.updateChart();
                });
            },
            selectExperts() {
                this.showUserSelection = true;
            },
            toggleShowCropper() {
                this.showCropper = !this.showCropper;
            },
            setAmbassador() {
                this.loading = true;
                this.$store.dispatch("getUserListForGroup", { grpId: 69 }).then(() => {
                    this.loading = false;
                    this.popup.title = "Choose Ambassador";
                    this.popup.template = "selectAmbassador";
                    this.popup.visible = true;
                    this.selectedUsrIdForAction = null;
                    this.selectedExperts = [];
                });
            },
            resetAmbassador() {
                confirm(
                    "Are you sure you want to reset the ambassador of this MFG?",
                    "Confirm Deletion"
                ).then((res) => {
                    if (res) {
                        this.loading = true;
                        this.$store
                            .dispatch("resetTopicAmbassador", {
                                usrId: this.selectedUsrIdForAction,
                                args: this.args,
                            })
                            .then((res) => {
                                this.loading = false;
                                if (res.data.success) {
                                    this.popup.visible = false;
                                    this.$store.dispatch("GetGenericFormData", {
                                        args: this.args,
                                        topicId: this.currentTopicId,
                                    });
                                    this.updateChart();
                                } else {
                                    alert("An error occured", "Reset Ambassador");
                                }
                            });
                    }
                });
            },
            setAmbassadorOnServer() {
                if (this.selectedUsrIdForAction == null) {
                    alert("Please select an user!", "Set Ambassador");
                    return;
                }
                this.loading = true;
                this.$store
                    .dispatch("setTopicAmbassador", {
                        usrId: this.selectedUsrIdForAction,
                        args: this.args,
                    })
                    .then((res) => {
                        this.loading = false;
                        if (res.data.success) {
                            this.popup.visible = false;
                            this.$store.dispatch("GetGenericFormData", {
                                args: this.args,
                                topicId: this.currentTopicId,
                            });
                            this.updateChart();
                        } else {
                            alert("An error occured", "Set Ambassador");
                        }
                    });
            },
            cropSuccess(imgDataUrl, field, value) {
                if (value) {
                    value.UpdateData = imgDataUrl;
                    value.Url = imgDataUrl;
                }
            },
            /**
             * upload success
             *
             * [param] jsonData  server api return data, already json encode
             * [param] field
             */
            //cropUploadSuccess(jsonData, field) {

            //},
            /**
             * upload fail
             *
             * [param] status    server api return error status, like 500
             * [param] field
             */
            cropUploadFail(status, field) {
                console.log("-------- upload fail --------");
                console.log(status);
                console.log("field: " + field);
            },

            ////////////////
            evaluate: function (code, args = {}) {
                // Call is used to define where "this" within the evaluated code should reference.
                // eval does not accept the likes of eval.call(...) or eval.apply(...) and cannot
                // be an arrow function
                return function evaluateEval() {
                    // Create an args definition list e.g. "arg1 = this.arg1, arg2 = this.arg2"
                    const argsStr = Object.keys(args)
                        .map((key) => `${key} = this.${key}`)
                        .join(",");
                    const argsDef = argsStr ? `let ${argsStr};` : "";

                    return eval(`${argsDef}${code}`);
                }.call(args);
            },
            isVisible: function (data) {
                if (data.VisibleCondition > "") {
                    try {
                        data.Visible = this.evaluate(data.VisibleCondition, this.record);
                    } catch (e) {
                        console.error(e);
                        data.Visible = false;
                    }
                } else {
                    data.Visible = true;
                }
                return data.Visible;
            },
            changeTopicStatus: function (status) {
                let validationResult = this.$refs.validationGroup.instance.validate();
                const popup = this.$refs.changeTopicStatusPopup;
                if (!validationResult.isValid) {
                    alert(
                        "You must fill in all marked fields before you can perform this action!",
                        "Confirm"
                    );
                    return;
                }
                if (!this.formIsReadOnly) {
                    this.$store
                        .dispatch("SaveGenericFormData", { submit: false, args: this.args })
                        .then((success) => {
                            if (success) {
                                popup.showTopicPopup(this.currentTopicId, status.StatusID);
                            } else {
                                alert("Error while saving your data");
                            }
                        });
                } else {
                    popup.showTopicPopup(this.currentTopicId, status.StatusID);
                }
            },
            addTopicLink(action) {
                this.actionTopicId = null;
                this.actionTopicIds = [];
                this.actionTlsId = action.TlsId;
                this.topicLinksForLinking.forEach((m) => m.selected == false);
                this.loading = true;
                this.$store
                    .dispatch("getTopicListForLinking", { tlsId: action.TlsId })
                    .then(() => {
                        this.loading = false;
                        this.popup.action = action;
                        this.popup.template = "addTopicLink";
                        this.popup.title = action.TltCreateButtonText;
                        this.popup.visible = true;
                        this.popup.multiselect = action.TlsMultiSelection;
                    });
            },
            addTopicLinkOnServer() {
                this.loading = true;
                var ids = this.actionTopicIds;
                if (!this.popup.multiselect) {
                    this.$store
                        .dispatch("addTopicLink", {
                            topicId1: this.currentTopicId,
                            idList: [this.actionTopicId],
                            tlsId: this.actionTlsId,
                            CategoryId: this.actionCategoryId,
                        })
                        .then((res) => {
                            this.loading = false;
                            if (res.data.success) {
                                this.loadingLinkListVisible = true;
                                this.$store
                                    .dispatch("getTopicLinkListEx", {
                                        topicId: this.currentTopicId,
                                        withPhoto: false,
                                    })
                                    .then(() => {
                                        this.loadingLinkListVisible = false;
                                        this.popup.visible = false;
                                        this.updateChart();
                                    });
                            } else {
                                alert("Error while adding topic link", "Error").then(() => {
                                    this.popup.visible = false;
                                });
                            }
                        });
                } else if (ids.length > 0) {
                    var promises = [];
                    promises.push(
                        this.$store.dispatch("addTopicLink", {
                            tlsId: this.actionTlsId,
                            topicId1: this.currentTopicId,
                            idList: ids,
                            categoryId: this.actionCategoryId,
                        })
                    );
                    Promise.all(promises).then((res) => {
                        this.loading = false;
                        if (!res.find((m) => !m.data.success)) {
                            this.loadingLinkListVisible = true;
                            this.$store
                                .dispatch("getTopicLinkListEx", {
                                    topicId: this.currentTopicId,
                                    withPhoto: false,
                                })
                                .then(() => {
                                    this.loadingLinkListVisible = false;
                                    this.popup.visible = false;
                                    this.updateChart();
                                });
                        } else {
                            alert("Error while adding topic link", "Error").then(() => {
                                this.popup.visible = false;
                            });
                        }
                    });
                }
            },
            statusActionClick(topicId, statusId, tliId) {
                const popup = this.$refs.changeTopicStatusPopup;
                popup
                    .showTopicLinkPopup(topicId, tliId, statusId)
                    //this.loading = true;
                    //this.$store.dispatch("changeTopicLinkStatus", { topicId, statusId, tliId })
                    .then(() => {
                        this.loadingLinkListVisible = true;
                        this.$store
                            .dispatch("getTopicLinkListEx", {
                                topicId: this.currentTopicId,
                                withPhoto: false,
                            })
                            .then(() => {
                                this.loadingLinkListVisible = false;
                                this.updateChart();
                            });
                    });
            },

            closeMultiselectPopup(data) {
                data.ShowSelectionPopup = false;
            },
            deleteMultiselectItem(data, rec) {
                data.SelectedKeys = data.SelectedKeys.filter((m) => m != rec.value);
                data.Value = data.SelectedKeys.join(",");
                var item = data.allItems.find((m) => m.value == rec.value);
                if (item) {
                    item.selected = false;
                    if (item.parentValue) {
                        var parent = data.allItems.find((m) => m.value == item.parentValue);
                        parent.selected = false;
                    }
                }
                findAndDeselect(data.groupData, rec.value);
            },

            addMultiselectItem(data) {
                data.ShowSelectionPopup = true;
            },
            getMaxLengthText(data) {
                if (!data.MaxLength || data.MaxLength == 0) {
                    return "";
                }
                const n =
                    data.Value && data.Value != null
                        ? data.MaxLength - data.Value.length
                        : data.MaxLength;
                return `${n} characters left`;
            },
            deleteImage(img, data) {
                let result = confirm(
                    "Are you sure you want to delete this document?",
                    "Confirm Deletion"
                );
                result.then((dialogResult) => {
                    if (dialogResult) {
                        this.loading = true;
                        this.$store
                            .dispatch("DeleteTopicFile", { args: this.args, img: img, data })
                            .then(() => {
                                this.loading = false;
                            });
                    }
                });
            },

            treeItemRender(e, data) {
                var hasParents =
                    data.SelectBoxItems.filter((m) => m.ParentValue > 0).length > 0;
                if (
                    hasParents &&
                    (e.itemData.parentValue == null || e.itemData.parentValue == "")
                ) {
                    e.itemElement.parentElement.style.paddingLeft = 0;
                    e.itemElement.parentElement
                        .getElementsByClassName("dx-checkbox")
                        .forEach((m) => {
                            return (m.style.display = "none");
                        });
                }
            },

            isTreeKeySelected(data, list) {
                var keys = [];

                if (data.hasParents) {
                    list.forEach((m) => {
                        if (m.selected) {
                            // && m.parentValue > 0)
                            keys.push(m.value);
                        }
                        if (m.items) {
                            keys = keys.concat(this.isTreeKeySelected(data, m.items));
                        }
                    });
                } else {
                    keys = data.listItems
                        .filter((m) => m.selected)
                        .map((m) => {
                            return m.value;
                        });
                }
                return keys;
            },
            treeClick(e, data) {
                switch (data.AtmId) {
                    case 2:
                        {
                            var list = data.SelectedKeys;
                            if (e.itemData.selected) {
                                list.push(e.itemData.value);
                            }
                            const count = data.listItems.filter(
                                (m) =>
                                    m.items.filter((i) => list.indexOf(i.value) >= 0).length > 0
                            ).length;
                            const max = data.listItems
                                .map((m) => {
                                    return m.items.filter((i) => list.indexOf(i.value) >= 0).length;
                                })
                                .max();
                            if (
                                (data.MaxLength > 0 &&
                                    data.MaxLength < count &&
                                    e.itemData.selected == true) ||
                                max > 3
                            ) {
                                e.component.unselectItem(e.itemElement);
                                if (!this.limitMessageShown) {
                                    alert(
                                        `Only a maximum of three elements per group from a maximum of ${data.MaxLength} groups can be selected.`,
                                        "Selection Limit"
                                    );
                                    this.limitMessageShown = true;
                                } else {
                                    this.limitMessageShown = false;
                                }
                            }
                        }
                        break;
                    default:
                        {
                            const count = data.SelectedKeys.length;
                            if (
                                data.MaxLength > 0 &&
                                data.MaxLength <= count &&
                                e.itemData.selected == true
                            ) {
                                e.component.unselectItem(e.itemElement);
                                if (!this.limitMessageShown) {
                                    alert(
                                        `only ${data.MaxLength} items can be selected`,
                                        "Selection Limit"
                                    );
                                    this.limitMessageShown = true;
                                }
                            }
                        }
                        break;
                }
            },

            multiSelectValuesChanged(e, data) {
                this.OnSelectionChanged(e, data);
            },

            treeViewSelectionChanged(e, data) {
                this.OnSelectionChanged(e, data);
            },

            OnSelectionChanged(e, data) {
                data.SelectedKeys = this.isTreeKeySelected(data, data.listItems);
                data.Value = data.SelectedKeys.join(", ");
            },

            getSelectedItems(data) {
                var result = [];
                if (!data.listItems) {
                    return [];
                }
                data.listItems.forEach((m) => {
                    if (m.items) {
                        m.items
                            .filter((i) => i.selected == true)
                            .forEach((i) => {
                                result.push(i);
                            });
                    }
                });
                return result;
            },
            processGrouped(data) {
                var list = data.SelectBoxItems;
                switch (data.AtyId) {
                    case 14:
                    case 20:
                    case 21:
                        break;
                    case 24:
                    default:
                        return data.listItems ? data.listItems : [];
                }
                if (data.listItems) {
                    return data.listItems;
                }
                var selectedKeys = data.SelectedKeys;
                var allItems = [];
                var result = list
                    .filter((m) => {
                        return m.ParentValue == null || m.ParentValue == "";
                    })
                    .map((m) => {
                        var subItems = [];
                        var ele1 = {
                            value: m.Value,
                            parentValue: m.ParentValue,
                            items: m.Items.map((i) => {
                                var ele2 = {
                                    value: i.Value,
                                    parentValue: i.ParentValue,
                                    text: i.Text,
                                    expand: true,
                                    selected: selectedKeys.indexOf(i.Value) >= 0,
                                    item: i,
                                };
                                subItems.push(ele2);
                                return ele2;
                            }),
                            text: m.Text,
                            selected: false,
                        };
                        allItems.push(ele1);
                        subItems.forEach((m) => allItems.push(m));
                        return ele1;
                    });
                // HIER: Sortierung nur für den gewünschten Fall
                if (data.AtyId === 21 && data.MatId === 907) {
                    debugger;
                    // Sortiere Hauptelemente
                    result.sort((a, b) => a.text.localeCompare(b.text));
                    // Sortiere Unterelemente
                    result.forEach((m) => {
                        if (m.items && m.items.length > 0) {
                            m.items.sort((a, b) => a.text.localeCompare(b.text));
                        }
                    });
                }
                data.hasParents = list.filter((m) => m.ParentValue > 0).length > 0;
                //if (!data.hasParents) {
                result.forEach((m) => {
                    m.selected = selectedKeys.indexOf(m.value) >= 0;
                });
                //}
                data.listItems = result;
                data.allItems = data.hasParents ? allItems : result;
                return result;
            },
            backToOverview() {
                // Deprecated – nutzt jetzt History
                this.navigateBack();
            },
            update() {
                this.loading = true;
                this.$store
                    .dispatch("SaveGenericFormData", { submit: false, args: this.args })
                    .then(() => {
                        this.loading = false;
                    });
            },
            //getDeepLink() {
            //    this.loading = true
            //    this.$store.dispatch("getDeepLink", { topicId = this.topicId })
            //        .then(res => {
            //            console.log(res);
            //            this.loading = false;
            //        });
            //},
            deleteTopic() {
                let msg =
                    this.currentTopicStatus.DeleteButtonMessage &&
                        this.currentTopicStatus.DeleteButtonMessage.length > 0
                        ? this.currentTopicStatus.DeleteButtonMessage
                        : "Are you sure you want to delete this record?";
                let result = confirm(msg, "Confirm Deletion");
                result.then((dialogResult) => {
                    if (dialogResult) {
                        this.loading = true;
                        this.$store
                            .dispatch("deleteTopic", {
                                topicId: this.currentTopicId,
                                args: this.args,
                            })
                            .then((res) => {
                                if (res.success) {
                                    this.backToOverview();
                                } else {
                                    this.loading = false;
                                }
                            });
                    }
                });
            },
            onSubmit(e) {
                debugger;
                if (document.fullscreenElement) {
                    e.preventDefault();
                    return;
                }
                if (this.submitAction) {
                    this.submitAction();
                    this.submitAction = null;
                    e.preventDefault();
                    return;
                }
                this.loadingStatus = true;
                this.loading = true;
                e.preventDefault();
                this.$store
                    .dispatch("SaveGenericFormData", { submit: true, args: this.args })
                    .then((res) => {
                        this.loading = false;
                        if (res.data.success) {
                            if (res.data.complete != true) {
                                alert(
                                    "Your application is not complete! Check the following fields: " +
                                    (res.data.missingItems
                                        ? res.data.missingItems
                                            .map((m) => m.FieldCaption)
                                            .join(", ")
                                        : "???"),
                                    "Submission"
                                );
                            } else {
                                this.backToOverview();
                            }
                        } else {
                            alert("Something went wrong!", "Submission");
                        }
                    });
            },
            handleMultiSelectText(items, keys, data) {
                if (items && keys && keys.length > 0) {
                    data.Value = keys.join(",");
                    return items
                        .filter((m) => keys.includes(m.Value))
                        .map((m) => {
                            return '<li class="msbEntry">' + m.Text + "</li>";
                        })
                        .join("");
                } else {
                    data.Value = null;
                    return "<li class='msbNoEntry'>- please select -</li>";
                }
            },
            handleDisplayText(items, data) {
                if (data.Value > 0) {
                    var result = "";
                    let item = data.SelectBoxItems.find((m) => m.Value == data.Value);
                    if (item) {
                        result = item.Text;
                    }
                    data.SelectedText = result;
                    return result;
                } else {
                    return "--";
                }
            },
            handleIcon(items, data) {
                if (data.Value > 0) {
                    let item = items.find((m) => m.Value == data.Value);
                    if (item) {
                        return item.Icon;
                    }
                } else {
                    return "--";
                }
            },
            makeBreaks(text) {
                return "<p>" + text.replace(/\n/g, "</p><p>") + "<p>";
            },
            removeFormatting(text) {
                var result = text.replace(/font-family:[^;]*;/gm, "");
                result = result.replace(/font-size:[^;]*;/gm, "");
                result = result.replace(/background-color:[^;]*;/gm, "");
                result = result.replace(/color:[^;]*;/gm, "");
                return result;
            },
            isUrl(value) {
                return /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(
                    value
                );
            },
            openDetail(topicId) {
                this.goto(topicId);
            },
            openEditLinkPopup(tliId, title, _linkedTopicId, isReversed = false) {
                axios
                    .get(baseUri + "/GetTopicLinkTopic", { params: { tliId: tliId } })
                    .then((res) => {
                        var topicId = res.data.TopicId;
                        var args = res.data.Args;
                        this.$nextTick(() =>
                            this.$refs.TopicLinkEntry.LoadData(topicId, args, title, isReversed)
                        );
                    });
            },
            openLinkedDetail(topicId) {
                // NOTE: If a link is not routing correctly, check Esa.TopicTypeEnum & TopicEntry.cs
                var data = {
                    action: "view",
                    id: topicId,
                    list: [topicId],
                    args: this.args,
                };
                var url = window.location.pathname;
                window.post(url, data);
                //this.goto(topicId);
            },
            goto(topicId) {
                return this.navigateToTopic(topicId, true);
            },
            handleTopicLinkSelectListClosed(value) {
                console.log(value);
            },
            gotoFirst() {
                if (this.topicIdList?.length) this.navigateToTopic(this.topicIdList[0]);
            },
            gotoPrevious() {
                const idx = this.topicIdList.indexOf(this.currentTopicId) - 1;
                if (idx >= 0) this.navigateToTopic(this.topicIdList[idx]);
            },
            gotoNext() {
                const idx = this.topicIdList.indexOf(this.currentTopicId) + 1;
                if (idx < this.topicIdList.length)
                    this.navigateToTopic(this.topicIdList[idx]);
            },
            gotoLast() {
                if (this.topicIdList?.length)
                    this.navigateToTopic(this.topicIdList[this.topicIdList.length - 1]);
            },
            addUploadParameter(e, data) {
                var minHeight =
                    data.MatOptionsParsed && data.MatOptionsParsed.MinHeight
                        ? data.MatOptionsParsed.MinHeight
                        : 0;
                var minWidth =
                    data.MatOptionsParsed && data.MatOptionsParsed.MinWidth
                        ? data.MatOptionsParsed.MinWidth
                        : 0;
                const uploadUrl =
                    baseUri +
                    "/UploadDocument" +
                    window.location.search +
                    "&MatId=" +
                    data.MatId +
                    "&TopicId=" +
                    this.topicId;
                e.component.option("uploadUrl", uploadUrl);
                if (data.MediaType == "Picture" && (minHeight > 0 || minWidth > 0)) {
                    var imgInfo = this.calculateImageSize(e.value[0]);
                    imgInfo.then((m) => {
                        if (m.width < minWidth || m.height < minHeight) {
                            alert(
                                "The image is too small.The minimum size is " +
                                "Please upload an image with a size of at least " +
                                minWidth +
                                "x" +
                                minHeight +
                                " px.",
                                "Image Size"
                            );
                            e.component.option("value", []);
                        }
                    });
                }
            },
            calculateImageSize(file) {
                if (!file) {
                    return new Promise(() => { });
                }
                return new Promise((resolve, reject) => {
                    const img = new Image();
                    img.onload = function () {
                        resolve({ width: this.width, height: this.height });
                    };
                    img.onerror = reject;
                    img.src = URL.createObjectURL(file);
                });
            },
            fileValidating(e, data) {
                if (e.rule && e.value && e.value.length > 0) {
                    var minHeight =
                        data.MatOptionsParsed && data.MatOptionsParsed.MinHeight
                            ? data.MatOptionsParsed.MinHeight
                            : 0;
                    var minWidth =
                        data.MatOptionsParsed && data.MatOptionsParsed.MinWidth
                            ? data.MatOptionsParsed.MinWidth
                            : 0;
                    if (data.MediaType == "Picture" && (minHeight > 0 || minWidth > 0)) {
                        var imgInfo = this.calculateImageSize(e.value[0]);
                        return imgInfo.then((m) => {
                            if (m.width < minWidth || m.height < minHeight) {
                                (e.rule.message =
                                    "The image is too small.The minimum size is " +
                                    "Please upload an image with a size of at least " +
                                    minWidth +
                                    "x" +
                                    minHeight +
                                    " px."),
                                    "Image Size";
                                e.rule.isValid = false;
                                e.validator.validate();
                                return false;
                            } else {
                                e.rule.isValid = true;
                                e.validator.validate();
                                return true;
                            }
                        });
                    }
                }
                return true;
            },
            fileUploaded(e, data) {
                var response = JSON.parse(e.request.responseText);
                if (response.success) {
                    response.files.forEach((m) => {
                        data.Value.push(m);
                    });
                } else {
                    alert(response.errorMessage, "File Upload");
                }
            },
        },
        props: {
            title: {
                type: String,
                required: false,
            },
            readOnly: {
                type: Boolean,
                required: false,
            },
            showStatusInfo: {
                type: Boolean,
                required: false,
            },
            showLinkList: {
                type: Boolean,
                required: false,
            },
            showGrids: {
                type: Boolean,
                required: false,
            },
            showAdminInfos: {
                type: Boolean,
                required: false,
            },
            showStatusActions: {
                type: Boolean,
                required: false,
            },
            showLinkStatusActions: {
                type: Boolean,
                required: false,
            },
            showNetworkList: {
                type: Boolean,
                required: false,
            },
            showOwner: {
                type: Boolean,
                required: false,
            },
        },
    };
</script>
<style>

    /* Neue Felder Styles */
    .new-version-fields {
        margin-top: 30px;
        border-top: 2px solid #4caf50;
        padding-top: 20px;
    }

    .new-fields-header {
        color: #4caf50 !important;
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 15px;
    }

    .added-field {
        background-color: #f0fff0;
        border-left: 4px solid #4caf50;
        padding: 15px;
        margin: 10px 0;
        border-radius: 4px;
    }

    .added-field-value {
        background-color: #e8f5e8;
        padding: 8px;
        border-radius: 3px;
        margin: 5px 0;
        font-weight: 500;
    }

    .added-field-info {
        color: #666;
        font-style: italic;
        margin-top: 5px;
    }

    /* Gelöschte Felder Styles */
    .deleted-version-fields {
        margin-top: 30px;
        border-top: 2px solid #f44336;
        padding-top: 20px;
    }

    .deleted-fields-header {
        color: #f44336 !important;
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 15px;
    }

    .deleted-field {
        background-color: #fff0f0;
        border-left: 4px solid #f44336;
        padding: 15px;
        margin: 10px 0;
        border-radius: 4px;
    }

    .deleted-field-value {
        background-color: #ffe8e8;
        padding: 8px;
        border-radius: 3px;
        margin: 5px 0;
        font-weight: 500;
        opacity: 0.7;
    }

    .deleted-field-info {
        color: #666;
        font-style: italic;
        margin-top: 5px;
    }

    .deleted-field-note {
        color: #f44336;
        font-size: 12px;
    }

    .crmCaption {
        font-weight: bold;
        padding-bottom: 0px;
    }

    .assigneeSelectionValue .dx-tag-remove-button::before {
        padding-left: 3px;
    }

    .crmAmbassadorAction span.dx-button-text {
        text-decoration: underline;
        color: #d44c22;
        font-size: 14px;
    }

    .tpc-date {
        font-weight: normal;
    }

    .crmDescription p {
        margin-block-start: unset;
        margin-block-end: unset;
    }
</style>
<style scoped>
    .tltTooltip {
        position: absolute;
        max-width: 300px;
        z-index: 10;
        background-color: #1e73be;
        color: white;
        padding: 2px 4px 2px 4px;
        border-radius: 4px;
        top: 40px;
        left: 123px;
    }

    .drawer-title.drawer-status-text span {
        padding: 10px;
    }

    .puCellTpl {
        display: contents;
    }

    .dx-show-invalid-badge.dx-numberbox.dx-texteditor.dx-editor-filled.dx-state-readonly.dx-widget.crmValidationBox.dx-validator.dx-visibility-change-handler {
        display: none;
    }

    .dx-datagrid {
        padding: 10px;
    }

    /*multiselect popup hide texeditor*/
    .crmMultiSelectListText .dx-texteditor.dx-editor-filled.dx-state-hover {
        background: none;
    }

    .tlLTopicId {
        font-weight: 600;
        justify-self: start;
    }

    .tlStatus {
        color: var(--m02-color-1);
        align-self: self-end;
    }

    .crmPhotoBox img {
        border-radius: 50%;
        height: 150px;
        object-fit: cover;
        width: 150px;
    }

    .tlLinkTemplate {
        cursor: pointer;
        align-self: flex-end;
        display: grid;
        grid-template-columns: auto auto;
        gap: 4px;
        justify-items: end;
    }

        .tlLinkTemplate span {
            color: var(--m01-color-1);
        }

    .statusChangedby {
    }

    .crmAmbassadorAction {
        padding: 0;
        margin-top: -5px;
    }

    .crmOwnerValue.crmControl {
        display: grid;
        width: 100%;
        grid-template-columns: auto auto;
    }

    .crmMultiSelectListText .dx-validator {
        background: none;
    }

    div#cisTey {
        display: grid;
        justify-content: right;
        grid-template-columns: 700px;
    }

    .crmDescription {
        padding-bottom: 10px;
    }

        .crmDescription.readOnly {
            font-weight: 550;
        }

    .tlStatusList {
        display: flex;
        gap: 10px;
        color: #d44c22;
        text-decoration: underline;
        cursor: pointer;
        justify-content: right;
        align-items: self-end;
    }

    .ttlIcon {
        text-align: center;
        padding-right: 2px;
    }

    .crmControl {
    }

    .crmRequired {
    }

    .crmDescription {
    }

    .crmUpload .dx-fileuploader-wrapper {
        padding-left: 0;
    }

    .crmImageBox {
        display: flex;
        gap: 10px;
        box-sizing: border-box;
        flex-wrap: wrap;
        row-gap: 34px;
    }

    .crmDownload {
        overflow: hidden;
        white-space: nowrap;
        /* word-break: break-all; */
        /* color: black; */
        font-size: 12px;
        padding: 7px 0;
        position: relative;
        /*left: 44px;*/
        /*top: 50px;*/
        z-index: 99;
        top: 7px;
        left: 100px;
    }

    .crmDownloadReadonly.crmDownloadReadonly {
        position: unset;
        display: none;
    }

    .crmDownload a {
        font-weight: 500;
        color: var(--m02-color-1);
        text-decoration: none;
    }

    .crmImages img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .crmImages {
        height: 200px;
        border: 1px solid silver;
        border-radius: 4px;
        width: 100%;
        padding: 2px;
    }

    .crmImageDiv,
    .crmImage {
        height: 100%;
        text-align: center;
    }

        .crmImage i {
            font-size: 152px;
            padding: 24px;
            color: #00a4e0;
        }

            .crmImage i:hover {
                color: #ea733b;
            }

    .crmContents {
        display: contents;
    }

        .crmContents.crmHeader {
            display: grid;
            grid-template-columns: auto 1fr;
            gap: 10px;
            margin-bottom: 10px;
            font-size: 15px;
        }

        .crmContents p {
            padding-bottom: 5px;
        }

    .crmContentsTitel {
        display: contents;
        color: var(--m02-color-1);
        font-weight: 600;
    }

    .crmImages {
        break-inside: avoid-column;
    }

    .crmButtons {
        margin-top: 20px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 10px;
    }

    .crmWidget {
        margin-bottom: 10px;
    }

    .msbListBox {
        min-height: 20px;
    }

    .msbList {
        display: block;
        list-style-type: disc;
        margin-block-start: 1em;
        margin-block-end: 1em;
        margin-inline-start: 0px;
        margin-inline-end: 0px;
        padding-inline-start: 40px;
    }

    li.msbNoEntry {
        list-style: none;
    }

    .crmAmbassadorAction {
        margin-bottom: 20px;
    }

    .msbEntry {
    }

    .crmControl {
        break-inside: auto;
    }

    div#cisTey.crmReadOnly {
        width: auto;
    }

    /* .crmReadOnly .crmContentArea {
        column-width: 300px;
        min-height: calc(100vh - 200px);
        column-count: 10;
    }*/

    .crmReadOnly .crmContentArea {
        display: block;
        column-gap: 10px;
        column-fill: balance-all;
        padding: 20px;
    }

        .crmReadOnly .crmContentArea .crmElements {
            margin-bottom: 10px;
            padding: 0;
        }

    .crmReadOnly .crmControl {
        margin-bottom: 20px;
    }

    /*.crmReadOnly .crmDownload {
        padding: 10px 5px;
    }*/

    .crmContentArea {
        max-width: 750px;
        padding-bottom: 20px;
    }

    .crmElements {
        padding: 10px 30px 10px 30px;
        margin-bottom: 0px;
    }

    .crmVotingArea {
        break-before: column;
    }

    .crmReadOnly .crmElements {
        display: block;
        break-inside: avoid;
        break-before: auto;
    }

    .crmReadOnly .crmBreakInside {
        break-inside: auto;
        break-before: column;
    }

    .crmReadOnly .crmCaption {
        break-after: avoid;
        break-inside: avoid;
        padding: 3px 0 0px 0;
        box-sizing: border-box;
        margin-bottom: 8px;
        border-radius: 2px;
    }

    .crmReadOnly .msbSelectBox {
        display: block;
    }

    .crmReadOnly .crmAmbassador {
        margin-bottom: 10px;
    }

    .crmTitle {
        font-size: 20px;
        margin-top: -5px;
        margin-bottom: 22px;
    }

    .crmReadOnly ul.msbList {
        padding: 0;
        margin: 5px 0;
    }

    .controlHeader {
        display: flex;
        gap: 10px;
    }

    .crmNavigator {
        gap: 5px;
        display: flex;
        margin-top: -2px;
    }

    .crmStatusButtons {
        display: flex;
        align-items: flex-start;
        gap: 10px;
    }

    .graph-box {
        padding: 0 30px;
    }

    .crmCurrentStatus {
        color: var(--m02-color-1);
    }

    .crmStatusButton {
    }

        .crmStatusButton .crmStatusAction {
            color: #d44c22;
            text-decoration: underline;
            cursor: pointer;
        }

    .msbSelectBox i {
        font-size: 40px;
        color: var(--danger-color);
    }

    .msbSelectBox {
        display: flex;
        gap: 10px;
    }

    .sbList {
        align-self: center;
    }

    .crmCommentArea {
        break-inside: avoid;
        break-before: column;
    }

    #cisTey .crmCommentArea .crmCaption {
    }

    .vdIcon {
        font-size: 36px;
        color: var(--danger-hover-color);
        margin: 10px 10px 10px 0;
        vertical-align: middle;
    }

        .vdIcon:hover {
            color: var(--flag-color-4);
        }

    .ttlIcon .vdIcon {
        font-size: 18px;
        margin: 0;
    }

    a.crmContents.crmHyperlink {
        color: #e97035;
    }

    .crmTitleCaption {
        font-size: 25px;
        padding-bottom: 20px;
    }

    .crmPageTitle {
        text-align: center;
    }

    .tlLinkItem {
        display: contents;
    }

        .tlLinkItem .tlLinkId:hover,
        .tlLinkItem .tlLinkTitle:hover {
            /*  font-weight: bold;*/
            cursor: pointer;
            color: var(--main-color-2);
        }

    .tlLinkListBox {
        display: grid;
        grid-template-columns: auto auto auto auto auto 1fr;
        gap: 10px;
        font-size: 14px;
        padding-bottom: 20px;
        overflow-y: scroll;
        max-height: 400px;
    }

    .tlStatusList {
        align-self: start;
    }

    .crmElements.tlLinkList {
    }

    .cluster-class .crmCaption {
    }

    .cluster-class .nodes .crmCaption {
        background-color: var(--m01-color-1);
    }

    .vdIcon .tooltiptext {
        visibility: hidden;
        width: 120px;
        color: black;
        background-color: var(--page-bg-color);
        font-family: var(--font-family);
        font-size: 12px;
        margin-left: 10px;
        /*text-align: center;*/
        border-radius: 6px;
        padding: 10px;
        /* Position the tooltip */
        position: absolute;
        box-shadow: 1px 2px 6px #888888;
        width: auto;
        max-width: 500px;
        z-index: 1;
        line-height: 1.3em;
    }

    .dx-show-invalid-badge.crmValidationBox.dx-validator {
        margin-top: 0;
    }

    .crmBackButton {
        margin-left: -8px;
    }

    .crmValidationBox input.dx-texteditor-input {
        visibility: hidden;
        height: 0;
        border: 0;
    }

    .crmImageDelete {
        position: relative;
        z-index: 100;
        top: -39px;
    }

    .vdIcon:hover .tooltiptext {
        visibility: visible;
    }

    .tlLinkType.crmCaption {
    }

    div#treeview {
        height: 250px;
        border: solid 1px silver;
        overflow: hidden;
    }

    .crmMaxLen {
        float: right;
        font-size: 12px;
    }

    .crmElementHeader {
        display: flex;
        justify-content: flex-start;
    }

    .crmDocumentDiv {
        width: 160px;
    }

    #app ul.crmMultiSelectListText {
        display: flex;
        flex-wrap: wrap;
        gap: 5px;
        list-style: none;
        margin: 0;
        padding: 0;
        list-style-type: none;
        margin-bottom: -40px;
    }

        #app ul.crmMultiSelectListText .dx-texteditor-input-container {
            color: transparent;
        }

    #app li.crmMultiSelectItem {
        display: grid;
        grid-template-columns: auto auto;
        gap: 5px;
        margin: 0;
        border: solid 1px silver;
        border-radius: 5px;
        padding: 10px;
        text-align: left;
        align-items: center;
        z-index: 99;
        background: white;
    }

    #app span.crmMultiSelectItemDelete {
        cursor: pointer;
        color: #ea7034;
    }

        #app span.crmMultiSelectItemDelete:hover {
            color: #00a4e0;
        }

    #app li.crmMultiSelectItemAdd {
        text-align: center;
        cursor: pointer;
        color: #ea7034;
    }

        #app li.crmMultiSelectItemAdd:hover {
            color: #00a4e0;
        }

    #app .crmMultiSelectIconAdd {
        padding-left: 5px;
    }

    .crmPopupContent {
        height: 100%;
        display: grid;
        grid-template-columns: auto;
        grid-template-rows: auto 1fr;
    }

    .crmNoPhoto {
        padding-bottom: 20px;
    }

    .crmPopupBody {
        display: contents;
    }

    .crmPopupFooter {
        justify-self: end;
        padding-top: 20px;
    }

    .crmNavigator .dx-button-content i:before {
        color: #0084b5;
        font-size: 15px;
    }

    .crmNavigator .dx-button-mode-text.dx-state-focused,
    .crmNavigator .dx-button-mode-text.dx-state-hover {
        background: transparent;
        color: #d44c22;
    }

    .page-content {
        width: 100%;
        display: grid;
        grid-template-columns: auto auto;
        margin: 10px 0px 10px 0px;
    }

    .crmStatusSubmitButtons {
        display: contents;
    }

    @media only screen and (max-width: 1200px) {
        div#cisTey {
            grid-template-columns: 600px;
        }

        .img-bg {
            display: none;
        }
    }

    .crmPhotoBox {
        display: flex;
        flex-direction: column;
        max-width: 200px;
    }

        .crmPhotoBox img {
            margin-bottom: 20px;
        }

    @media only screen and (max-width: 600px) {
        .crmButtons {
            margin-top: 20px;
            display: flex;
            flex-direction: row;
            gap: 10px;
            justify-content: space-evenly;
        }

        div#cisTey {
            grid-template-columns: 400px;
        }
    }

    @media only screen and (max-width: 350px) {
        div#cisTey {
            grid-template-columns: 250px;
        }
    }

    .crmCheckbox {
        margin-left: 10px;
    }

    .pqHeadFirst {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 10px;
    }

    input[type="range"] {
        -webkit-appearance: none !important;
        outline: none !important;
        opacity: 0.7 !important;
        -webkit-transition: 0.2s !important;
        transition: opacity 0.2s !important;
    }

        input[type="range"]:hover {
            opacity: 1 !important;
        }

        input[type="range"]::-webkit-slider-thumb {
            -webkit-appearance: none !important;
            appearance: none !important;
            background: red !important;
        }

        input[type="range"]::-moz-range-thumb {
            background: #e97035 !important;
        }

        input[type="range"]::-webkit-slider-thumb {
            background: #e97035 !important;
        }

        input[type="range"]::-webkit-slider-runnable-track {
            background: #00a3df !important;
        }
    /*    div.dx-texteditor-input-container input.dx-texteditor-input {
        padding: 20px 156px 3px !important;
    }*/
    .drawer-elements,
    .drawerGrid-elements {
        background-color: rgba(0, 164, 224, 0.08);
        padding: 10px;
        border-radius: 0px 0px 5px 5px;
    }

    .grid-element {
        margin-top: 10px;
    }

    .drawer-btn {
        width: 100%;
        margin-bottom: 1px;
        padding-right: 20px;
        padding-left: 20px;
        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
    }

    .drawers {
        margin-bottom: 15px;
    }

    .crmElements.drawer {
        padding: 0px;
    }

    .slack-class.crmElements {
        padding-top: 0px;
    }

    .slack-class .crmMaxLen {
        display: none;
    }

    .slack-checkbox-class {
        padding-bottom: 10px;
        margin-bottom: -10px;
    }

    .slack-class .crmDescription {
        margin-top: -17px;
    }

    .puCell {
        display: grid;
        grid-template-columns: auto auto;
        gap: 20px;
        min-width: 300px;
    }

    .dx-overlay-content .dx-item.dx-treeview-item {
        margin-left: 0;
    }

    .tliEditButton {
        cursor: pointer;
    }

        .tliEditButton:hover {
            color: var(--m02-color-1);
        }
    /* Accordion mapping styles */
    .map-group-static {
        margin-top: 8px;
    }

    .map-static-title {
        background: #f5f7fa;
        border: 1px solid #e1e4e8;
        border-radius: 4px;
        padding: 6px 8px;
        font-weight: 600;
        display: flex;
        gap: 6px;
        align-items: center;
    }

    .map-static-body {
        padding: 6px 10px 4px 14px;
    }

    .map-acc-title {
        display: flex;
        gap: 6px;
        align-items: center;
        font-weight: 600;
    }

    .map-acc-count {
        font-weight: 400;
        color: #666;
        font-size: 12px;
    }

    .map-acc-body {
        padding: 6px 10px 4px 14px;
        border-left: 2px solid #e3e6ea;
        margin-left: 6px;
    }
</style>
